"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a, b, c, d) {
    function e(b, c) {
        this.settings = null, this.options = a.extend({}, e.Defaults, c), this.$element = a(b), this.drag = a.extend({}, m), this.state = a.extend({}, n), this.e = a.extend({}, o), this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._invalidated = {}, this._pipe = [], a.each(e.Plugins, a.proxy(function (a, b) {
            this._plugins[a[0].toLowerCase() + a.slice(1)] = new b(this);
        }, this)), a.each(e.Pipe, a.proxy(function (b, c) {
            this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
        }, this)), this.setup(), this.initialize();
    }function f(a) {
        if (a.touches !== d) return { x: a.touches[0].pageX, y: a.touches[0].pageY };if (a.touches === d) {
            if (a.pageX !== d) return { x: a.pageX, y: a.pageY };if (a.pageX === d) return { x: a.clientX, y: a.clientY };
        }
    }function g(a) {
        var b,
            d,
            e = c.createElement("div"),
            f = a;for (b in f) {
            if (d = f[b], "undefined" != typeof e.style[d]) return e = null, [d, b];
        }return [!1];
    }function h() {
        return g(["transition", "WebkitTransition", "MozTransition", "OTransition"])[1];
    }function i() {
        return g(["transform", "WebkitTransform", "MozTransform", "OTransform", "msTransform"])[0];
    }function j() {
        return g(["perspective", "webkitPerspective", "MozPerspective", "OPerspective", "MsPerspective"])[0];
    }function k() {
        return "ontouchstart" in b || !!navigator.msMaxTouchPoints;
    }function l() {
        return b.navigator.msPointerEnabled;
    }var m, n, o;m = { start: 0, startX: 0, startY: 0, current: 0, currentX: 0, currentY: 0, offsetX: 0, offsetY: 0, distance: null, startTime: 0, endTime: 0, updatedX: 0, targetEl: null }, n = { isTouch: !1, isScrolling: !1, isSwiping: !1, direction: !1, inMotion: !1 }, o = { _onDragStart: null, _onDragMove: null, _onDragEnd: null, _transitionEnd: null, _resizer: null, _responsiveCall: null, _goToLoop: null, _checkVisibile: null }, e.Defaults = { items: 3, loop: !1, center: !1, mouseDrag: !0, touchDrag: !0, pullDrag: !0, freeDrag: !1, margin: 0, stagePadding: 0, merge: !1, mergeFit: !0, autoWidth: !1, startPosition: 0, rtl: !1, smartSpeed: 250, fluidSpeed: !1, dragEndSpeed: !1, responsive: {}, responsiveRefreshRate: 200, responsiveBaseElement: b, responsiveClass: !1, fallbackEasing: "swing", info: !1, nestedItemSelector: !1, itemElement: "div", stageElement: "div", themeClass: "owl-theme", baseClass: "owl-carousel", itemClass: "owl-item", centerClass: "center", activeClass: "active" }, e.Width = { Default: "default", Inner: "inner", Outer: "outer" }, e.Plugins = {}, e.Pipe = [{ filter: ["width", "items", "settings"], run: function run(a) {
            a.current = this._items && this._items[this.relative(this._current)];
        } }, { filter: ["items", "settings"], run: function run() {
            var a = this._clones,
                b = this.$stage.children(".cloned");(b.length !== a.length || !this.settings.loop && a.length > 0) && (this.$stage.children(".cloned").remove(), this._clones = []);
        } }, { filter: ["items", "settings"], run: function run() {
            var a,
                b,
                c = this._clones,
                d = this._items,
                e = this.settings.loop ? c.length - Math.max(2 * this.settings.items, 4) : 0;for (a = 0, b = Math.abs(e / 2); b > a; a++) {
                e > 0 ? (this.$stage.children().eq(d.length + c.length - 1).remove(), c.pop(), this.$stage.children().eq(0).remove(), c.pop()) : (c.push(c.length / 2), this.$stage.append(d[c[c.length - 1]].clone().addClass("cloned")), c.push(d.length - 1 - (c.length - 1) / 2), this.$stage.prepend(d[c[c.length - 1]].clone().addClass("cloned")));
            }
        } }, { filter: ["width", "items", "settings"], run: function run() {
            var a,
                b,
                c,
                d = this.settings.rtl ? 1 : -1,
                e = (this.width() / this.settings.items).toFixed(3),
                f = 0;for (this._coordinates = [], b = 0, c = this._clones.length + this._items.length; c > b; b++) {
                a = this._mergers[this.relative(b)], a = this.settings.mergeFit && Math.min(a, this.settings.items) || a, f += (this.settings.autoWidth ? this._items[this.relative(b)].width() + this.settings.margin : e * a) * d, this._coordinates.push(f);
            }
        } }, { filter: ["width", "items", "settings"], run: function run() {
            var b,
                c,
                d = (this.width() / this.settings.items).toFixed(3),
                e = { width: Math.abs(this._coordinates[this._coordinates.length - 1]) + 2 * this.settings.stagePadding, "padding-left": this.settings.stagePadding || "", "padding-right": this.settings.stagePadding || "" };if (this.$stage.css(e), e = { width: this.settings.autoWidth ? "auto" : d - this.settings.margin }, e[this.settings.rtl ? "margin-left" : "margin-right"] = this.settings.margin, !this.settings.autoWidth && a.grep(this._mergers, function (a) {
                return a > 1;
            }).length > 0) for (b = 0, c = this._coordinates.length; c > b; b++) {
                e.width = Math.abs(this._coordinates[b]) - Math.abs(this._coordinates[b - 1] || 0) - this.settings.margin, this.$stage.children().eq(b).css(e);
            } else this.$stage.children().css(e);
        } }, { filter: ["width", "items", "settings"], run: function run(a) {
            a.current && this.reset(this.$stage.children().index(a.current));
        } }, { filter: ["position"], run: function run() {
            this.animate(this.coordinates(this._current));
        } }, { filter: ["width", "position", "items", "settings"], run: function run() {
            var a,
                b,
                c,
                d,
                e = this.settings.rtl ? 1 : -1,
                f = 2 * this.settings.stagePadding,
                g = this.coordinates(this.current()) + f,
                h = g + this.width() * e,
                i = [];for (c = 0, d = this._coordinates.length; d > c; c++) {
                a = this._coordinates[c - 1] || 0, b = Math.abs(this._coordinates[c]) + f * e, (this.op(a, "<=", g) && this.op(a, ">", h) || this.op(b, "<", g) && this.op(b, ">", h)) && i.push(c);
            }this.$stage.children("." + this.settings.activeClass).removeClass(this.settings.activeClass), this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass(this.settings.activeClass), this.settings.center && (this.$stage.children("." + this.settings.centerClass).removeClass(this.settings.centerClass), this.$stage.children().eq(this.current()).addClass(this.settings.centerClass));
        } }], e.prototype.initialize = function () {
        if (this.trigger("initialize"), this.$element.addClass(this.settings.baseClass).addClass(this.settings.themeClass).toggleClass("owl-rtl", this.settings.rtl), this.browserSupport(), this.settings.autoWidth && this.state.imagesLoaded !== !0) {
            var b, c, e;if (b = this.$element.find("img"), c = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, e = this.$element.children(c).width(), b.length && 0 >= e) return this.preloadAutoWidthImages(b), !1;
        }this.$element.addClass("owl-loading"), this.$stage = a("<" + this.settings.stageElement + ' class="owl-stage"/>').wrap('<div class="owl-stage-outer">'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this._width = this.$element.width(), this.refresh(), this.$element.removeClass("owl-loading").addClass("owl-loaded"), this.eventsCall(), this.internalEvents(), this.addTriggerableEvents(), this.trigger("initialized");
    }, e.prototype.setup = function () {
        var b = this.viewport(),
            c = this.options.responsive,
            d = -1,
            e = null;c ? (a.each(c, function (a) {
            b >= a && a > d && (d = Number(a));
        }), e = a.extend({}, this.options, c[d]), delete e.responsive, e.responsiveClass && this.$element.attr("class", function (a, b) {
            return b.replace(/\b owl-responsive-\S+/g, "");
        }).addClass("owl-responsive-" + d)) : e = a.extend({}, this.options), (null === this.settings || this._breakpoint !== d) && (this.trigger("change", { property: { name: "settings", value: e } }), this._breakpoint = d, this.settings = e, this.invalidate("settings"), this.trigger("changed", { property: { name: "settings", value: this.settings } }));
    }, e.prototype.optionsLogic = function () {
        this.$element.toggleClass("owl-center", this.settings.center), this.settings.loop && this._items.length < this.settings.items && (this.settings.loop = !1), this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1);
    }, e.prototype.prepare = function (b) {
        var c = this.trigger("prepare", { content: b });return c.data || (c.data = a("<" + this.settings.itemElement + "/>").addClass(this.settings.itemClass).append(b)), this.trigger("prepared", { content: c.data }), c.data;
    }, e.prototype.update = function () {
        for (var b = 0, c = this._pipe.length, d = a.proxy(function (a) {
            return this[a];
        }, this._invalidated), e = {}; c > b;) {
            (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
        }this._invalidated = {};
    }, e.prototype.width = function (a) {
        switch (a = a || e.Width.Default) {case e.Width.Inner:case e.Width.Outer:
                return this._width;default:
                return this._width - 2 * this.settings.stagePadding + this.settings.margin;}
    }, e.prototype.refresh = function () {
        if (0 === this._items.length) return !1;new Date().getTime();this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$stage.addClass("owl-refresh"), this.update(), this.$stage.removeClass("owl-refresh"), this.state.orientation = b.orientation, this.watchVisibility(), this.trigger("refreshed");
    }, e.prototype.eventsCall = function () {
        this.e._onDragStart = a.proxy(function (a) {
            this.onDragStart(a);
        }, this), this.e._onDragMove = a.proxy(function (a) {
            this.onDragMove(a);
        }, this), this.e._onDragEnd = a.proxy(function (a) {
            this.onDragEnd(a);
        }, this), this.e._onResize = a.proxy(function (a) {
            this.onResize(a);
        }, this), this.e._transitionEnd = a.proxy(function (a) {
            this.transitionEnd(a);
        }, this), this.e._preventClick = a.proxy(function (a) {
            this.preventClick(a);
        }, this);
    }, e.prototype.onThrottledResize = function () {
        b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this.e._onResize, this.settings.responsiveRefreshRate);
    }, e.prototype.onResize = function () {
        return this._items.length ? this._width === this.$element.width() ? !1 : this.trigger("resize").isDefaultPrevented() ? !1 : (this._width = this.$element.width(), this.invalidate("width"), this.refresh(), void this.trigger("resized")) : !1;
    }, e.prototype.eventsRouter = function (a) {
        var b = a.type;"mousedown" === b || "touchstart" === b ? this.onDragStart(a) : "mousemove" === b || "touchmove" === b ? this.onDragMove(a) : "mouseup" === b || "touchend" === b ? this.onDragEnd(a) : "touchcancel" === b && this.onDragEnd(a);
    }, e.prototype.internalEvents = function () {
        var c = (k(), l());this.settings.mouseDrag ? (this.$stage.on("mousedown", a.proxy(function (a) {
            this.eventsRouter(a);
        }, this)), this.$stage.on("dragstart", function () {
            return !1;
        }), this.$stage.get(0).onselectstart = function () {
            return !1;
        }) : this.$element.addClass("owl-text-select-on"), this.settings.touchDrag && !c && this.$stage.on("touchstart touchcancel", a.proxy(function (a) {
            this.eventsRouter(a);
        }, this)), this.transitionEndVendor && this.on(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd, !1), this.settings.responsive !== !1 && this.on(b, "resize", a.proxy(this.onThrottledResize, this));
    }, e.prototype.onDragStart = function (d) {
        var e, g, h, i;if (e = d.originalEvent || d || b.event, 3 === e.which || this.state.isTouch) return !1;if ("mousedown" === e.type && this.$stage.addClass("owl-grab"), this.trigger("drag"), this.drag.startTime = new Date().getTime(), this.speed(0), this.state.isTouch = !0, this.state.isScrolling = !1, this.state.isSwiping = !1, this.drag.distance = 0, g = f(e).x, h = f(e).y, this.drag.offsetX = this.$stage.position().left, this.drag.offsetY = this.$stage.position().top, this.settings.rtl && (this.drag.offsetX = this.$stage.position().left + this.$stage.width() - this.width() + this.settings.margin), this.state.inMotion && this.support3d) i = this.getTransformProperty(), this.drag.offsetX = i, this.animate(i), this.state.inMotion = !0;else if (this.state.inMotion && !this.support3d) return this.state.inMotion = !1, !1;this.drag.startX = g - this.drag.offsetX, this.drag.startY = h - this.drag.offsetY, this.drag.start = g - this.drag.startX, this.drag.targetEl = e.target || e.srcElement, this.drag.updatedX = this.drag.start, ("IMG" === this.drag.targetEl.tagName || "A" === this.drag.targetEl.tagName) && (this.drag.targetEl.draggable = !1), a(c).on("mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents", a.proxy(function (a) {
            this.eventsRouter(a);
        }, this));
    }, e.prototype.onDragMove = function (a) {
        var c, e, g, h, i, j;this.state.isTouch && (this.state.isScrolling || (c = a.originalEvent || a || b.event, e = f(c).x, g = f(c).y, this.drag.currentX = e - this.drag.startX, this.drag.currentY = g - this.drag.startY, this.drag.distance = this.drag.currentX - this.drag.offsetX, this.drag.distance < 0 ? this.state.direction = this.settings.rtl ? "right" : "left" : this.drag.distance > 0 && (this.state.direction = this.settings.rtl ? "left" : "right"), this.settings.loop ? this.op(this.drag.currentX, ">", this.coordinates(this.minimum())) && "right" === this.state.direction ? this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length) : this.op(this.drag.currentX, "<", this.coordinates(this.maximum())) && "left" === this.state.direction && (this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length)) : (h = this.coordinates(this.settings.rtl ? this.maximum() : this.minimum()), i = this.coordinates(this.settings.rtl ? this.minimum() : this.maximum()), j = this.settings.pullDrag ? this.drag.distance / 5 : 0, this.drag.currentX = Math.max(Math.min(this.drag.currentX, h + j), i + j)), (this.drag.distance > 8 || this.drag.distance < -8) && (c.preventDefault !== d ? c.preventDefault() : c.returnValue = !1, this.state.isSwiping = !0), this.drag.updatedX = this.drag.currentX, (this.drag.currentY > 16 || this.drag.currentY < -16) && this.state.isSwiping === !1 && (this.state.isScrolling = !0, this.drag.updatedX = this.drag.start), this.animate(this.drag.updatedX)));
    }, e.prototype.onDragEnd = function (b) {
        var d, e, f;if (this.state.isTouch) {
            if ("mouseup" === b.type && this.$stage.removeClass("owl-grab"), this.trigger("dragged"), this.drag.targetEl.removeAttribute("draggable"), this.state.isTouch = !1, this.state.isScrolling = !1, this.state.isSwiping = !1, 0 === this.drag.distance && this.state.inMotion !== !0) return this.state.inMotion = !1, !1;this.drag.endTime = new Date().getTime(), d = this.drag.endTime - this.drag.startTime, e = Math.abs(this.drag.distance), (e > 3 || d > 300) && this.removeClick(this.drag.targetEl), f = this.closest(this.drag.updatedX), this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(f), this.invalidate("position"), this.update(), this.settings.pullDrag || this.drag.updatedX !== this.coordinates(f) || this.transitionEnd(), this.drag.distance = 0, a(c).off(".owl.dragEvents");
        }
    }, e.prototype.removeClick = function (c) {
        this.drag.targetEl = c, a(c).on("click.preventClick", this.e._preventClick), b.setTimeout(function () {
            a(c).off("click.preventClick");
        }, 300);
    }, e.prototype.preventClick = function (b) {
        b.preventDefault ? b.preventDefault() : b.returnValue = !1, b.stopPropagation && b.stopPropagation(), a(b.target).off("click.preventClick");
    }, e.prototype.getTransformProperty = function () {
        var a, c;return a = b.getComputedStyle(this.$stage.get(0), null).getPropertyValue(this.vendorName + "transform"), a = a.replace(/matrix(3d)?\(|\)/g, "").split(","), c = 16 === a.length, c !== !0 ? a[4] : a[12];
    }, e.prototype.closest = function (b) {
        var c = -1,
            d = 30,
            e = this.width(),
            f = this.coordinates();return this.settings.freeDrag || a.each(f, a.proxy(function (a, g) {
            return b > g - d && g + d > b ? c = a : this.op(b, "<", g) && this.op(b, ">", f[a + 1] || g - e) && (c = "left" === this.state.direction ? a + 1 : a), -1 === c;
        }, this)), this.settings.loop || (this.op(b, ">", f[this.minimum()]) ? c = b = this.minimum() : this.op(b, "<", f[this.maximum()]) && (c = b = this.maximum())), c;
    }, e.prototype.animate = function (b) {
        this.trigger("translate"), this.state.inMotion = this.speed() > 0, this.support3d ? this.$stage.css({ transform: "translate3d(" + b + "px,0px, 0px)", transition: this.speed() / 1e3 + "s" }) : this.state.isTouch ? this.$stage.css({ left: b + "px" }) : this.$stage.animate({ left: b }, this.speed() / 1e3, this.settings.fallbackEasing, a.proxy(function () {
            this.state.inMotion && this.transitionEnd();
        }, this));
    }, e.prototype.current = function (a) {
        if (a === d) return this._current;if (0 === this._items.length) return d;if (a = this.normalize(a), this._current !== a) {
            var b = this.trigger("change", { property: { name: "position", value: a } });b.data !== d && (a = this.normalize(b.data)), this._current = a, this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } });
        }return this._current;
    }, e.prototype.invalidate = function (a) {
        this._invalidated[a] = !0;
    }, e.prototype.reset = function (a) {
        a = this.normalize(a), a !== d && (this._speed = 0, this._current = a, this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"]));
    }, e.prototype.normalize = function (b, c) {
        var e = c ? this._items.length : this._items.length + this._clones.length;return !a.isNumeric(b) || 1 > e ? d : b = this._clones.length ? (b % e + e) % e : Math.max(this.minimum(c), Math.min(this.maximum(c), b));
    }, e.prototype.relative = function (a) {
        return a = this.normalize(a), a -= this._clones.length / 2, this.normalize(a, !0);
    }, e.prototype.maximum = function (a) {
        var b,
            c,
            d,
            e = 0,
            f = this.settings;if (a) return this._items.length - 1;if (!f.loop && f.center) b = this._items.length - 1;else if (f.loop || f.center) {
            if (f.loop || f.center) b = this._items.length + f.items;else {
                if (!f.autoWidth && !f.merge) throw "Can not detect maximum absolute position.";for (revert = f.rtl ? 1 : -1, c = this.$stage.width() - this.$element.width(); (d = this.coordinates(e)) && !(d * revert >= c);) {
                    b = ++e;
                }
            }
        } else b = this._items.length - f.items;return b;
    }, e.prototype.minimum = function (a) {
        return a ? 0 : this._clones.length / 2;
    }, e.prototype.items = function (a) {
        return a === d ? this._items.slice() : (a = this.normalize(a, !0), this._items[a]);
    }, e.prototype.mergers = function (a) {
        return a === d ? this._mergers.slice() : (a = this.normalize(a, !0), this._mergers[a]);
    }, e.prototype.clones = function (b) {
        var c = this._clones.length / 2,
            e = c + this._items.length,
            f = function f(a) {
            return a % 2 === 0 ? e + a / 2 : c - (a + 1) / 2;
        };return b === d ? a.map(this._clones, function (a, b) {
            return f(b);
        }) : a.map(this._clones, function (a, c) {
            return a === b ? f(c) : null;
        });
    }, e.prototype.speed = function (a) {
        return a !== d && (this._speed = a), this._speed;
    }, e.prototype.coordinates = function (b) {
        var c = null;return b === d ? a.map(this._coordinates, a.proxy(function (a, b) {
            return this.coordinates(b);
        }, this)) : (this.settings.center ? (c = this._coordinates[b], c += (this.width() - c + (this._coordinates[b - 1] || 0)) / 2 * (this.settings.rtl ? -1 : 1)) : c = this._coordinates[b - 1] || 0, c);
    }, e.prototype.duration = function (a, b, c) {
        return Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
    }, e.prototype.to = function (c, d) {
        if (this.settings.loop) {
            var e = c - this.relative(this.current()),
                f = this.current(),
                g = this.current(),
                h = this.current() + e,
                i = 0 > g - h ? !0 : !1,
                j = this._clones.length + this._items.length;h < this.settings.items && i === !1 ? (f = g + this._items.length, this.reset(f)) : h >= j - this.settings.items && i === !0 && (f = g - this._items.length, this.reset(f)), b.clearTimeout(this.e._goToLoop), this.e._goToLoop = b.setTimeout(a.proxy(function () {
                this.speed(this.duration(this.current(), f + e, d)), this.current(f + e), this.update();
            }, this), 30);
        } else this.speed(this.duration(this.current(), c, d)), this.current(c), this.update();
    }, e.prototype.next = function (a) {
        a = a || !1, this.to(this.relative(this.current()) + 1, a);
    }, e.prototype.prev = function (a) {
        a = a || !1, this.to(this.relative(this.current()) - 1, a);
    }, e.prototype.transitionEnd = function (a) {
        return a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0)) ? !1 : (this.state.inMotion = !1, void this.trigger("translated"));
    }, e.prototype.viewport = function () {
        var d;if (this.options.responsiveBaseElement !== b) d = a(this.options.responsiveBaseElement).width();else if (b.innerWidth) d = b.innerWidth;else {
            if (!c.documentElement || !c.documentElement.clientWidth) throw "Can not detect viewport width.";d = c.documentElement.clientWidth;
        }return d;
    }, e.prototype.replace = function (b) {
        this.$stage.empty(), this._items = [], b && (b = b instanceof jQuery ? b : a(b)), this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)), b.filter(function () {
            return 1 === this.nodeType;
        }).each(a.proxy(function (a, b) {
            b = this.prepare(b), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1);
        }, this)), this.reset(a.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items");
    }, e.prototype.add = function (a, b) {
        b = b === d ? this._items.length : this.normalize(b, !0), this.trigger("add", { content: a, position: b }), 0 === this._items.length || b === this._items.length ? (this.$stage.append(a), this._items.push(a), this._mergers.push(1 * a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)) : (this._items[b].before(a), this._items.splice(b, 0, a), this._mergers.splice(b, 0, 1 * a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)), this.invalidate("items"), this.trigger("added", { content: a, position: b });
    }, e.prototype.remove = function (a) {
        a = this.normalize(a, !0), a !== d && (this.trigger("remove", { content: this._items[a], position: a }), this._items[a].remove(), this._items.splice(a, 1), this._mergers.splice(a, 1), this.invalidate("items"), this.trigger("removed", { content: null, position: a }));
    }, e.prototype.addTriggerableEvents = function () {
        var b = a.proxy(function (b, c) {
            return a.proxy(function (a) {
                a.relatedTarget !== this && (this.suppress([c]), b.apply(this, [].slice.call(arguments, 1)), this.release([c]));
            }, this);
        }, this);a.each({ next: this.next, prev: this.prev, to: this.to, destroy: this.destroy, refresh: this.refresh, replace: this.replace, add: this.add, remove: this.remove }, a.proxy(function (a, c) {
            this.$element.on(a + ".owl.carousel", b(c, a + ".owl.carousel"));
        }, this));
    }, e.prototype.watchVisibility = function () {
        function c(a) {
            return a.offsetWidth > 0 && a.offsetHeight > 0;
        }function d() {
            c(this.$element.get(0)) && (this.$element.removeClass("owl-hidden"), this.refresh(), b.clearInterval(this.e._checkVisibile));
        }c(this.$element.get(0)) || (this.$element.addClass("owl-hidden"), b.clearInterval(this.e._checkVisibile), this.e._checkVisibile = b.setInterval(a.proxy(d, this), 500));
    }, e.prototype.preloadAutoWidthImages = function (b) {
        var c, d, e, f;c = 0, d = this, b.each(function (g, h) {
            e = a(h), f = new Image(), f.onload = function () {
                c++, e.attr("src", f.src), e.css("opacity", 1), c >= b.length && (d.state.imagesLoaded = !0, d.initialize());
            }, f.src = e.attr("src") || e.attr("data-src") || e.attr("data-src-retina");
        });
    }, e.prototype.destroy = function () {
        this.$element.hasClass(this.settings.themeClass) && this.$element.removeClass(this.settings.themeClass), this.settings.responsive !== !1 && a(b).off("resize.owl.carousel"), this.transitionEndVendor && this.off(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd);for (var d in this._plugins) {
            this._plugins[d].destroy();
        }(this.settings.mouseDrag || this.settings.touchDrag) && (this.$stage.off("mousedown touchstart touchcancel"), a(c).off(".owl.dragEvents"), this.$stage.get(0).onselectstart = function () {}, this.$stage.off("dragstart", function () {
            return !1;
        })), this.$element.off(".owl"), this.$stage.children(".cloned").remove(), this.e = null, this.$element.removeData("owlCarousel"), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.unwrap();
    }, e.prototype.op = function (a, b, c) {
        var d = this.settings.rtl;switch (b) {case "<":
                return d ? a > c : c > a;case ">":
                return d ? c > a : a > c;case ">=":
                return d ? c >= a : a >= c;case "<=":
                return d ? a >= c : c >= a;}
    }, e.prototype.on = function (a, b, c, d) {
        a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c);
    }, e.prototype.off = function (a, b, c, d) {
        a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c);
    }, e.prototype.trigger = function (b, c, d) {
        var e = { item: { count: this._items.length, index: this.current() } },
            f = a.camelCase(a.grep(["on", b, d], function (a) {
            return a;
        }).join("-").toLowerCase()),
            g = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({ relatedTarget: this }, e, c));return this._supress[b] || (a.each(this._plugins, function (a, b) {
            b.onTrigger && b.onTrigger(g);
        }), this.$element.trigger(g), this.settings && "function" == typeof this.settings[f] && this.settings[f].apply(this, g)), g;
    }, e.prototype.suppress = function (b) {
        a.each(b, a.proxy(function (a, b) {
            this._supress[b] = !0;
        }, this));
    }, e.prototype.release = function (b) {
        a.each(b, a.proxy(function (a, b) {
            delete this._supress[b];
        }, this));
    }, e.prototype.browserSupport = function () {
        if (this.support3d = j(), this.support3d) {
            this.transformVendor = i();var a = ["transitionend", "webkitTransitionEnd", "transitionend", "oTransitionEnd"];this.transitionEndVendor = a[h()], this.vendorName = this.transformVendor.replace(/Transform/i, ""), this.vendorName = "" !== this.vendorName ? "-" + this.vendorName.toLowerCase() + "-" : "";
        }this.state.orientation = b.orientation;
    }, a.fn.owlCarousel = function (b) {
        return this.each(function () {
            a(this).data("owlCarousel") || a(this).data("owlCarousel", new e(this, b));
        });
    }, a.fn.owlCarousel.Constructor = e;
}(window.Zepto || window.jQuery, window, document), function (a, b) {
    var c = function c(b) {
        this._core = b, this._loaded = [], this._handlers = { "initialized.owl.carousel change.owl.carousel": a.proxy(function (b) {
                if (b.namespace && this._core.settings && this._core.settings.lazyLoad && (b.property && "position" == b.property.name || "initialized" == b.type)) for (var c = this._core.settings, d = c.center && Math.ceil(c.items / 2) || c.items, e = c.center && -1 * d || 0, f = (b.property && b.property.value || this._core.current()) + e, g = this._core.clones().length, h = a.proxy(function (a, b) {
                    this.load(b);
                }, this); e++ < d;) {
                    this.load(g / 2 + this._core.relative(f)), g && a.each(this._core.clones(this._core.relative(f++)), h);
                }
            }, this) }, this._core.options = a.extend({}, c.Defaults, this._core.options), this._core.$element.on(this._handlers);
    };c.Defaults = { lazyLoad: !1 }, c.prototype.load = function (c) {
        var d = this._core.$stage.children().eq(c),
            e = d && d.find(".owl-lazy");!e || a.inArray(d.get(0), this._loaded) > -1 || (e.each(a.proxy(function (c, d) {
            var e,
                f = a(d),
                g = b.devicePixelRatio > 1 && f.attr("data-src-retina") || f.attr("data-src");this._core.trigger("load", { element: f, url: g }, "lazy"), f.is("img") ? f.one("load.owl.lazy", a.proxy(function () {
                f.css("opacity", 1), this._core.trigger("loaded", { element: f, url: g }, "lazy");
            }, this)).attr("src", g) : (e = new Image(), e.onload = a.proxy(function () {
                f.css({ "background-image": "url(" + g + ")", opacity: "1" }), this._core.trigger("loaded", { element: f, url: g }, "lazy");
            }, this), e.src = g);
        }, this)), this._loaded.push(d.get(0)));
    }, c.prototype.destroy = function () {
        var a, b;for (a in this.handlers) {
            this._core.$element.off(a, this.handlers[a]);
        }for (b in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[b] && (this[b] = null);
        }
    }, a.fn.owlCarousel.Constructor.Plugins.Lazy = c;
}(window.Zepto || window.jQuery, window, document), function (a) {
    var b = function b(c) {
        this._core = c, this._handlers = { "initialized.owl.carousel": a.proxy(function () {
                this._core.settings.autoHeight && this.update();
            }, this), "changed.owl.carousel": a.proxy(function (a) {
                this._core.settings.autoHeight && "position" == a.property.name && this.update();
            }, this), "loaded.owl.lazy": a.proxy(function (a) {
                this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass) === this._core.$stage.children().eq(this._core.current()) && this.update();
            }, this) }, this._core.options = a.extend({}, b.Defaults, this._core.options), this._core.$element.on(this._handlers);
    };b.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }, b.prototype.update = function () {
        this._core.$stage.parent().height(this._core.$stage.children().eq(this._core.current()).height()).addClass(this._core.settings.autoHeightClass);
    }, b.prototype.destroy = function () {
        var a, b;for (a in this._handlers) {
            this._core.$element.off(a, this._handlers[a]);
        }for (b in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[b] && (this[b] = null);
        }
    }, a.fn.owlCarousel.Constructor.Plugins.AutoHeight = b;
}(window.Zepto || window.jQuery, window, document), function (a, b, c) {
    var d = function d(b) {
        this._core = b, this._videos = {}, this._playing = null, this._fullscreen = !1, this._handlers = { "resize.owl.carousel": a.proxy(function (a) {
                this._core.settings.video && !this.isInFullScreen() && a.preventDefault();
            }, this), "refresh.owl.carousel changed.owl.carousel": a.proxy(function () {
                this._playing && this.stop();
            }, this), "prepared.owl.carousel": a.proxy(function (b) {
                var c = a(b.content).find(".owl-video");c.length && (c.css("display", "none"), this.fetch(c, a(b.content)));
            }, this) }, this._core.options = a.extend({}, d.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", a.proxy(function (a) {
            this.play(a);
        }, this));
    };d.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }, d.prototype.fetch = function (a, b) {
        var c = a.attr("data-vimeo-id") ? "vimeo" : "youtube",
            d = a.attr("data-vimeo-id") || a.attr("data-youtube-id"),
            e = a.attr("data-width") || this._core.settings.videoWidth,
            f = a.attr("data-height") || this._core.settings.videoHeight,
            g = a.attr("href");if (!g) throw new Error("Missing video URL.");if (d = g.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), d[3].indexOf("youtu") > -1) c = "youtube";else {
            if (!(d[3].indexOf("vimeo") > -1)) throw new Error("Video URL not supported.");c = "vimeo";
        }d = d[6], this._videos[g] = { type: c, id: d, width: e, height: f }, b.attr("data-video", g), this.thumbnail(a, this._videos[g]);
    }, d.prototype.thumbnail = function (b, c) {
        var d,
            e,
            f,
            g = c.width && c.height ? 'style="width:' + c.width + "px;height:" + c.height + 'px;"' : "",
            h = b.find("img"),
            i = "src",
            j = "",
            k = this._core.settings,
            l = function l(a) {
            e = '<div class="owl-video-play-icon"></div>', d = k.lazyLoad ? '<div class="owl-video-tn ' + j + '" ' + i + '="' + a + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + a + ')"></div>', b.after(d), b.after(e);
        };return b.wrap('<div class="owl-video-wrapper"' + g + "></div>"), this._core.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length ? (l(h.attr(i)), h.remove(), !1) : void ("youtube" === c.type ? (f = "https://img.youtube.com/vi/" + c.id + "/hqdefault.jpg", l(f)) : "vimeo" === c.type && a.ajax({ type: "GET", url: "https://vimeo.com/api/v2/video/" + c.id + ".json", jsonp: "callback", dataType: "jsonp", success: function success(a) {
                f = a[0].thumbnail_large, l(f);
            } }));
    }, d.prototype.stop = function () {
        this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null;
    }, d.prototype.play = function (b) {
        this._core.trigger("play", null, "video"), this._playing && this.stop();var c,
            d,
            e = a(b.target || b.srcElement),
            f = e.closest("." + this._core.settings.itemClass),
            g = this._videos[f.attr("data-video")],
            h = g.width || "100%",
            i = g.height || this._core.$stage.height();"youtube" === g.type ? c = '<iframe width="' + h + '" height="' + i + '" src="https://www.youtube.com/embed/' + g.id + "?autoplay=1&v=" + g.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === g.type && (c = '<iframe src="https://player.vimeo.com/video/' + g.id + '?autoplay=1" width="' + h + '" height="' + i + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'), f.addClass("owl-video-playing"), this._playing = f, d = a('<div style="height:' + i + "px; width:" + h + 'px" class="owl-video-frame">' + c + "</div>"), e.after(d);
    }, d.prototype.isInFullScreen = function () {
        var d = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;return d && a(d).parent().hasClass("owl-video-frame") && (this._core.speed(0), this._fullscreen = !0), d && this._fullscreen && this._playing ? !1 : this._fullscreen ? (this._fullscreen = !1, !1) : this._playing && this._core.state.orientation !== b.orientation ? (this._core.state.orientation = b.orientation, !1) : !0;
    }, d.prototype.destroy = function () {
        var a, b;this._core.$element.off("click.owl.video");for (a in this._handlers) {
            this._core.$element.off(a, this._handlers[a]);
        }for (b in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[b] && (this[b] = null);
        }
    }, a.fn.owlCarousel.Constructor.Plugins.Video = d;
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
    var e = function e(b) {
        this.core = b, this.core.options = a.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = d, this.next = d, this.handlers = { "change.owl.carousel": a.proxy(function (a) {
                "position" == a.property.name && (this.previous = this.core.current(), this.next = a.property.value);
            }, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
                this.swapping = "translated" == a.type;
            }, this), "translate.owl.carousel": a.proxy(function () {
                this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
            }, this) }, this.core.$element.on(this.handlers);
    };e.Defaults = { animateOut: !1, animateIn: !1 }, e.prototype.swap = function () {
        if (1 === this.core.settings.items && this.core.support3d) {
            this.core.speed(0);var b,
                c = a.proxy(this.clear, this),
                d = this.core.$stage.children().eq(this.previous),
                e = this.core.$stage.children().eq(this.next),
                f = this.core.settings.animateIn,
                g = this.core.settings.animateOut;this.core.current() !== this.previous && (g && (b = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d.css({ left: b + "px" }).addClass("animated owl-animated-out").addClass(g).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", c)), f && e.addClass("animated owl-animated-in").addClass(f).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", c));
        }
    }, e.prototype.clear = function (b) {
        a(b.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.transitionEnd();
    }, e.prototype.destroy = function () {
        var a, b;for (a in this.handlers) {
            this.core.$element.off(a, this.handlers[a]);
        }for (b in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[b] && (this[b] = null);
        }
    }, a.fn.owlCarousel.Constructor.Plugins.Animate = e;
}(window.Zepto || window.jQuery, window, document), function (a, b, c) {
    var d = function d(b) {
        this.core = b, this.core.options = a.extend({}, d.Defaults, this.core.options), this.handlers = { "translated.owl.carousel refreshed.owl.carousel": a.proxy(function () {
                this.autoplay();
            }, this), "play.owl.autoplay": a.proxy(function (a, b, c) {
                this.play(b, c);
            }, this), "stop.owl.autoplay": a.proxy(function () {
                this.stop();
            }, this), "mouseover.owl.autoplay": a.proxy(function () {
                this.core.settings.autoplayHoverPause && this.pause();
            }, this), "mouseleave.owl.autoplay": a.proxy(function () {
                this.core.settings.autoplayHoverPause && this.autoplay();
            }, this) }, this.core.$element.on(this.handlers);
    };d.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }, d.prototype.autoplay = function () {
        this.core.settings.autoplay && !this.core.state.videoPlay ? (b.clearInterval(this.interval), this.interval = b.setInterval(a.proxy(function () {
            this.play();
        }, this), this.core.settings.autoplayTimeout)) : b.clearInterval(this.interval);
    }, d.prototype.play = function () {
        return c.hidden === !0 || this.core.state.isTouch || this.core.state.isScrolling || this.core.state.isSwiping || this.core.state.inMotion ? void 0 : this.core.settings.autoplay === !1 ? void b.clearInterval(this.interval) : void this.core.next(this.core.settings.autoplaySpeed);
    }, d.prototype.stop = function () {
        b.clearInterval(this.interval);
    }, d.prototype.pause = function () {
        b.clearInterval(this.interval);
    }, d.prototype.destroy = function () {
        var a, c;b.clearInterval(this.interval);for (a in this.handlers) {
            this.core.$element.off(a, this.handlers[a]);
        }for (c in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[c] && (this[c] = null);
        }
    }, a.fn.owlCarousel.Constructor.Plugins.autoplay = d;
}(window.Zepto || window.jQuery, window, document), function (a) {
    "use strict";
    var b = function b(c) {
        this._core = c, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }, this._handlers = { "prepared.owl.carousel": a.proxy(function (b) {
                this._core.settings.dotsData && this._templates.push(a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"));
            }, this), "add.owl.carousel": a.proxy(function (b) {
                this._core.settings.dotsData && this._templates.splice(b.position, 0, a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"));
            }, this), "remove.owl.carousel prepared.owl.carousel": a.proxy(function (a) {
                this._core.settings.dotsData && this._templates.splice(a.position, 1);
            }, this), "change.owl.carousel": a.proxy(function (a) {
                if ("position" == a.property.name && !this._core.state.revert && !this._core.settings.loop && this._core.settings.navRewind) {
                    var b = this._core.current(),
                        c = this._core.maximum(),
                        d = this._core.minimum();a.data = a.property.value > c ? b >= c ? d : c : a.property.value < d ? c : a.property.value;
                }
            }, this), "changed.owl.carousel": a.proxy(function (a) {
                "position" == a.property.name && this.draw();
            }, this), "refreshed.owl.carousel": a.proxy(function () {
                this._initialized || (this.initialize(), this._initialized = !0), this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation");
            }, this) }, this._core.options = a.extend({}, b.Defaults, this._core.options), this.$element.on(this._handlers);
    };b.Defaults = { nav: !1, navRewind: !0, navText: ["prev", "next"], navSpeed: !1, navElement: "div", navContainer: !1, navContainerClass: "owl-nav", navClass: ["owl-prev", "owl-next"], slideBy: 1, dotClass: "owl-dot", dotsClass: "owl-dots", dots: !0, dotsEach: !1, dotData: !1, dotsSpeed: !1, dotsContainer: !1, controlsClass: "owl-controls" }, b.prototype.initialize = function () {
        var b,
            c,
            d = this._core.settings;d.dotsData || (this._templates = [a("<div>").addClass(d.dotClass).append(a("<span>")).prop("outerHTML")]), d.navContainer && d.dotsContainer || (this._controls.$container = a("<div>").addClass(d.controlsClass).appendTo(this.$element)), this._controls.$indicators = d.dotsContainer ? a(d.dotsContainer) : a("<div>").hide().addClass(d.dotsClass).appendTo(this._controls.$container), this._controls.$indicators.on("click", "div", a.proxy(function (b) {
            var c = a(b.target).parent().is(this._controls.$indicators) ? a(b.target).index() : a(b.target).parent().index();b.preventDefault(), this.to(c, d.dotsSpeed);
        }, this)), b = d.navContainer ? a(d.navContainer) : a("<div>").addClass(d.navContainerClass).prependTo(this._controls.$container), this._controls.$next = a("<" + d.navElement + ">"), this._controls.$previous = this._controls.$next.clone(), this._controls.$previous.addClass(d.navClass[0]).html(d.navText[0]).hide().prependTo(b).on("click", a.proxy(function () {
            this.prev(d.navSpeed);
        }, this)), this._controls.$next.addClass(d.navClass[1]).html(d.navText[1]).hide().appendTo(b).on("click", a.proxy(function () {
            this.next(d.navSpeed);
        }, this));for (c in this._overrides) {
            this._core[c] = a.proxy(this[c], this);
        }
    }, b.prototype.destroy = function () {
        var a, b, c, d;for (a in this._handlers) {
            this.$element.off(a, this._handlers[a]);
        }for (b in this._controls) {
            this._controls[b].remove();
        }for (d in this.overides) {
            this._core[d] = this._overrides[d];
        }for (c in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[c] && (this[c] = null);
        }
    }, b.prototype.update = function () {
        var a,
            b,
            c,
            d = this._core.settings,
            e = this._core.clones().length / 2,
            f = e + this._core.items().length,
            g = d.center || d.autoWidth || d.dotData ? 1 : d.dotsEach || d.items;if ("page" !== d.slideBy && (d.slideBy = Math.min(d.slideBy, d.items)), d.dots || "page" == d.slideBy) for (this._pages = [], a = e, b = 0, c = 0; f > a; a++) {
            (b >= g || 0 === b) && (this._pages.push({ start: a - e, end: a - e + g - 1 }), b = 0, ++c), b += this._core.mergers(this._core.relative(a));
        }
    }, b.prototype.draw = function () {
        var b,
            c,
            d = "",
            e = this._core.settings,
            f = (this._core.$stage.children(), this._core.relative(this._core.current()));if (!e.nav || e.loop || e.navRewind || (this._controls.$previous.toggleClass("disabled", 0 >= f), this._controls.$next.toggleClass("disabled", f >= this._core.maximum())), this._controls.$previous.toggle(e.nav), this._controls.$next.toggle(e.nav), e.dots) {
            if (b = this._pages.length - this._controls.$indicators.children().length, e.dotData && 0 !== b) {
                for (c = 0; c < this._controls.$indicators.children().length; c++) {
                    d += this._templates[this._core.relative(c)];
                }this._controls.$indicators.html(d);
            } else b > 0 ? (d = new Array(b + 1).join(this._templates[0]), this._controls.$indicators.append(d)) : 0 > b && this._controls.$indicators.children().slice(b).remove();this._controls.$indicators.find(".active").removeClass("active"), this._controls.$indicators.children().eq(a.inArray(this.current(), this._pages)).addClass("active");
        }this._controls.$indicators.toggle(e.dots);
    }, b.prototype.onTrigger = function (b) {
        var c = this._core.settings;b.page = { index: a.inArray(this.current(), this._pages), count: this._pages.length, size: c && (c.center || c.autoWidth || c.dotData ? 1 : c.dotsEach || c.items) };
    }, b.prototype.current = function () {
        var b = this._core.relative(this._core.current());return a.grep(this._pages, function (a) {
            return a.start <= b && a.end >= b;
        }).pop();
    }, b.prototype.getPosition = function (b) {
        var c,
            d,
            e = this._core.settings;return "page" == e.slideBy ? (c = a.inArray(this.current(), this._pages), d = this._pages.length, b ? ++c : --c, c = this._pages[(c % d + d) % d].start) : (c = this._core.relative(this._core.current()), d = this._core.items().length, b ? c += e.slideBy : c -= e.slideBy), c;
    }, b.prototype.next = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
    }, b.prototype.prev = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
    }, b.prototype.to = function (b, c, d) {
        var e;d ? a.proxy(this._overrides.to, this._core)(b, c) : (e = this._pages.length, a.proxy(this._overrides.to, this._core)(this._pages[(b % e + e) % e].start, c));
    }, a.fn.owlCarousel.Constructor.Plugins.Navigation = b;
}(window.Zepto || window.jQuery, window, document), function (a, b) {
    "use strict";
    var c = function c(d) {
        this._core = d, this._hashes = {}, this.$element = this._core.$element, this._handlers = { "initialized.owl.carousel": a.proxy(function () {
                "URLHash" == this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation");
            }, this), "prepared.owl.carousel": a.proxy(function (b) {
                var c = a(b.content).find("[data-hash]").andSelf("[data-hash]").attr("data-hash");this._hashes[c] = b.content;
            }, this) }, this._core.options = a.extend({}, c.Defaults, this._core.options), this.$element.on(this._handlers), a(b).on("hashchange.owl.navigation", a.proxy(function () {
            var a = b.location.hash.substring(1),
                c = this._core.$stage.children(),
                d = this._hashes[a] && c.index(this._hashes[a]) || 0;return a ? void this._core.to(d, !1, !0) : !1;
        }, this));
    };c.Defaults = { URLhashListener: !1 }, c.prototype.destroy = function () {
        var c, d;a(b).off("hashchange.owl.navigation");for (c in this._handlers) {
            this._core.$element.off(c, this._handlers[c]);
        }for (d in Object.getOwnPropertyNames(this)) {
            "function" != typeof this[d] && (this[d] = null);
        }
    }, a.fn.owlCarousel.Constructor.Plugins.Hash = c;
}(window.Zepto || window.jQuery, window, document);

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!function (a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
    "use strict";
    var b = window.Slick || {};b = function () {
        function c(c, d) {
            var f,
                e = this;e.defaults = { accessibility: !0, adaptiveHeight: !1, appendArrows: a(c), appendDots: a(c), arrows: !0, asNavFor: null, prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>', nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>', autoplay: !1, autoplaySpeed: 3e3, centerMode: !1, centerPadding: "50px", cssEase: "ease", customPaging: function customPaging(b, c) {
                    return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c + 1);
                }, dots: !1, dotsClass: "slick-dots", draggable: !0, easing: "linear", edgeFriction: .35, fade: !1, focusOnSelect: !1, infinite: !0, initialSlide: 0, lazyLoad: "ondemand", mobileFirst: !1, pauseOnHover: !0, pauseOnFocus: !0, pauseOnDotsHover: !1, respondTo: "window", responsive: null, rows: 1, rtl: !1, slide: "", slidesPerRow: 1, slidesToShow: 1, slidesToScroll: 1, speed: 500, swipe: !0, swipeToSlide: !1, touchMove: !0, touchThreshold: 5, useCSS: !0, useTransform: !0, variableWidth: !1, vertical: !1, verticalSwiping: !1, waitForAnimate: !0, zIndex: 1e3 }, e.initials = { animating: !1, dragging: !1, autoPlayTimer: null, currentDirection: 0, currentLeft: null, currentSlide: 0, direction: 1, $dots: null, listWidth: null, listHeight: null, loadIndex: 0, $nextArrow: null, $prevArrow: null, slideCount: null, slideWidth: null, $slideTrack: null, $slides: null, sliding: !1, slideOffset: 0, swipeLeft: null, $list: null, touchObject: {}, transformsEnabled: !1, unslicked: !1 }, a.extend(e, e.initials), e.activeBreakpoint = null, e.animType = null, e.animProp = null, e.breakpoints = [], e.breakpointSettings = [], e.cssTransitions = !1, e.focussed = !1, e.interrupted = !1, e.hidden = "hidden", e.paused = !0, e.positionProp = null, e.respondTo = null, e.rowCount = 1, e.shouldClick = !0, e.$slider = a(c), e.$slidesCache = null, e.transformType = null, e.transitionType = null, e.visibilityChange = "visibilitychange", e.windowWidth = 0, e.windowTimer = null, f = a(c).data("slick") || {}, e.options = a.extend({}, e.defaults, d, f), e.currentSlide = e.options.initialSlide, e.originalSettings = e.options, "undefined" != typeof document.mozHidden ? (e.hidden = "mozHidden", e.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.webkitHidden && (e.hidden = "webkitHidden", e.visibilityChange = "webkitvisibilitychange"), e.autoPlay = a.proxy(e.autoPlay, e), e.autoPlayClear = a.proxy(e.autoPlayClear, e), e.autoPlayIterator = a.proxy(e.autoPlayIterator, e), e.changeSlide = a.proxy(e.changeSlide, e), e.clickHandler = a.proxy(e.clickHandler, e), e.selectHandler = a.proxy(e.selectHandler, e), e.setPosition = a.proxy(e.setPosition, e), e.swipeHandler = a.proxy(e.swipeHandler, e), e.dragHandler = a.proxy(e.dragHandler, e), e.keyHandler = a.proxy(e.keyHandler, e), e.instanceUid = b++, e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, e.registerBreakpoints(), e.init(!0);
        }var b = 0;return c;
    }(), b.prototype.activateADA = function () {
        var a = this;a.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
    }, b.prototype.addSlide = b.prototype.slickAdd = function (b, c, d) {
        var e = this;if ("boolean" == typeof c) d = c, c = null;else if (0 > c || c >= e.slideCount) return !1;e.unload(), "number" == typeof c ? 0 === c && 0 === e.$slides.length ? a(b).appendTo(e.$slideTrack) : d ? a(b).insertBefore(e.$slides.eq(c)) : a(b).insertAfter(e.$slides.eq(c)) : d === !0 ? a(b).prependTo(e.$slideTrack) : a(b).appendTo(e.$slideTrack), e.$slides = e.$slideTrack.children(this.options.slide), e.$slideTrack.children(this.options.slide).detach(), e.$slideTrack.append(e.$slides), e.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b);
        }), e.$slidesCache = e.$slides, e.reinit();
    }, b.prototype.animateHeight = function () {
        var a = this;if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({ height: b }, a.options.speed);
        }
    }, b.prototype.animateSlide = function (b, c) {
        var d = {},
            e = this;e.animateHeight(), e.options.rtl === !0 && e.options.vertical === !1 && (b = -b), e.transformsEnabled === !1 ? e.options.vertical === !1 ? e.$slideTrack.animate({ left: b }, e.options.speed, e.options.easing, c) : e.$slideTrack.animate({ top: b }, e.options.speed, e.options.easing, c) : e.cssTransitions === !1 ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft), a({ animStart: e.currentLeft }).animate({ animStart: b }, { duration: e.options.speed, easing: e.options.easing, step: function step(a) {
                a = Math.ceil(a), e.options.vertical === !1 ? (d[e.animType] = "translate(" + a + "px, 0px)", e.$slideTrack.css(d)) : (d[e.animType] = "translate(0px," + a + "px)", e.$slideTrack.css(d));
            }, complete: function complete() {
                c && c.call();
            } })) : (e.applyTransition(), b = Math.ceil(b), e.options.vertical === !1 ? d[e.animType] = "translate3d(" + b + "px, 0px, 0px)" : d[e.animType] = "translate3d(0px," + b + "px, 0px)", e.$slideTrack.css(d), c && setTimeout(function () {
            e.disableTransition(), c.call();
        }, e.options.speed));
    }, b.prototype.getNavTarget = function () {
        var b = this,
            c = b.options.asNavFor;return c && null !== c && (c = a(c).not(b.$slider)), c;
    }, b.prototype.asNavFor = function (b) {
        var c = this,
            d = c.getNavTarget();null !== d && "object" == (typeof d === "undefined" ? "undefined" : _typeof(d)) && d.each(function () {
            var c = a(this).slick("getSlick");c.unslicked || c.slideHandler(b, !0);
        });
    }, b.prototype.applyTransition = function (a) {
        var b = this,
            c = {};b.options.fade === !1 ? c[b.transitionType] = b.transformType + " " + b.options.speed + "ms " + b.options.cssEase : c[b.transitionType] = "opacity " + b.options.speed + "ms " + b.options.cssEase, b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }, b.prototype.autoPlay = function () {
        var a = this;a.autoPlayClear(), a.slideCount > a.options.slidesToShow && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed));
    }, b.prototype.autoPlayClear = function () {
        var a = this;a.autoPlayTimer && clearInterval(a.autoPlayTimer);
    }, b.prototype.autoPlayIterator = function () {
        var a = this,
            b = a.currentSlide + a.options.slidesToScroll;a.paused || a.interrupted || a.focussed || (a.options.infinite === !1 && (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1 ? a.direction = 0 : 0 === a.direction && (b = a.currentSlide - a.options.slidesToScroll, a.currentSlide - 1 === 0 && (a.direction = 1))), a.slideHandler(b));
    }, b.prototype.buildArrows = function () {
        var b = this;b.options.arrows === !0 && (b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow"), b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow"), b.slideCount > b.options.slidesToShow ? (b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.prependTo(b.options.appendArrows), b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows), b.options.infinite !== !0 && b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
    }, b.prototype.buildDots = function () {
        var c,
            d,
            b = this;if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
            for (b.$slider.addClass("slick-dotted"), d = a("<ul />").addClass(b.options.dotsClass), c = 0; c <= b.getDotCount(); c += 1) {
                d.append(a("<li />").append(b.options.customPaging.call(this, b, c)));
            }b.$dots = d.appendTo(b.options.appendDots), b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
        }
    }, b.prototype.buildOut = function () {
        var b = this;b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), b.slideCount = b.$slides.length, b.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b).data("originalStyling", a(c).attr("style") || "");
        }), b.$slider.addClass("slick-slider"), b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent(), b.$list = b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), b.$slideTrack.css("opacity", 0), (b.options.centerMode === !0 || b.options.swipeToSlide === !0) && (b.options.slidesToScroll = 1), a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"), b.setupInfinite(), b.buildArrows(), b.buildDots(), b.updateDots(), b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0), b.options.draggable === !0 && b.$list.addClass("draggable");
    }, b.prototype.buildRows = function () {
        var b,
            c,
            d,
            e,
            f,
            g,
            h,
            a = this;if (e = document.createDocumentFragment(), g = a.$slider.children(), a.options.rows > 1) {
            for (h = a.options.slidesPerRow * a.options.rows, f = Math.ceil(g.length / h), b = 0; f > b; b++) {
                var i = document.createElement("div");for (c = 0; c < a.options.rows; c++) {
                    var j = document.createElement("div");for (d = 0; d < a.options.slidesPerRow; d++) {
                        var k = b * h + (c * a.options.slidesPerRow + d);g.get(k) && j.appendChild(g.get(k));
                    }i.appendChild(j);
                }e.appendChild(i);
            }a.$slider.empty().append(e), a.$slider.children().children().children().css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
        }
    }, b.prototype.checkResponsive = function (b, c) {
        var e,
            f,
            g,
            d = this,
            h = !1,
            i = d.$slider.width(),
            j = window.innerWidth || a(window).width();if ("window" === d.respondTo ? g = j : "slider" === d.respondTo ? g = i : "min" === d.respondTo && (g = Math.min(j, i)), d.options.responsive && d.options.responsive.length && null !== d.options.responsive) {
            f = null;for (e in d.breakpoints) {
                d.breakpoints.hasOwnProperty(e) && (d.originalSettings.mobileFirst === !1 ? g < d.breakpoints[e] && (f = d.breakpoints[e]) : g > d.breakpoints[e] && (f = d.breakpoints[e]));
            }null !== f ? null !== d.activeBreakpoint ? (f !== d.activeBreakpoint || c) && (d.activeBreakpoint = f, "unslick" === d.breakpointSettings[f] ? d.unslick(f) : (d.options = a.extend({}, d.originalSettings, d.breakpointSettings[f]), b === !0 && (d.currentSlide = d.options.initialSlide), d.refresh(b)), h = f) : (d.activeBreakpoint = f, "unslick" === d.breakpointSettings[f] ? d.unslick(f) : (d.options = a.extend({}, d.originalSettings, d.breakpointSettings[f]), b === !0 && (d.currentSlide = d.options.initialSlide), d.refresh(b)), h = f) : null !== d.activeBreakpoint && (d.activeBreakpoint = null, d.options = d.originalSettings, b === !0 && (d.currentSlide = d.options.initialSlide), d.refresh(b), h = f), b || h === !1 || d.$slider.trigger("breakpoint", [d, h]);
        }
    }, b.prototype.changeSlide = function (b, c) {
        var f,
            g,
            h,
            d = this,
            e = a(b.currentTarget);switch (e.is("a") && b.preventDefault(), e.is("li") || (e = e.closest("li")), h = d.slideCount % d.options.slidesToScroll !== 0, f = h ? 0 : (d.slideCount - d.currentSlide) % d.options.slidesToScroll, b.data.message) {case "previous":
                g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f, d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide - g, !1, c);break;case "next":
                g = 0 === f ? d.options.slidesToScroll : f, d.slideCount > d.options.slidesToShow && d.slideHandler(d.currentSlide + g, !1, c);break;case "index":
                var i = 0 === b.data.index ? 0 : b.data.index || e.index() * d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i), !1, c), e.children().trigger("focus");break;default:
                return;}
    }, b.prototype.checkNavigable = function (a) {
        var c,
            d,
            b = this;if (c = b.getNavigableIndexes(), d = 0, a > c[c.length - 1]) a = c[c.length - 1];else for (var e in c) {
            if (a < c[e]) {
                a = d;break;
            }d = c[e];
        }return a;
    }, b.prototype.cleanUpEvents = function () {
        var b = this;b.options.dots && null !== b.$dots && a("li", b.$dots).off("click.slick", b.changeSlide).off("mouseenter.slick", a.proxy(b.interrupt, b, !0)).off("mouseleave.slick", a.proxy(b.interrupt, b, !1)), b.$slider.off("focus.slick blur.slick"), b.options.arrows === !0 && b.slideCount > b.options.slidesToShow && (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide), b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide)), b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler), b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler), b.$list.off("touchend.slick mouseup.slick", b.swipeHandler), b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler), b.$list.off("click.slick", b.clickHandler), a(document).off(b.visibilityChange, b.visibility), b.cleanUpSlideEvents(), b.options.accessibility === !0 && b.$list.off("keydown.slick", b.keyHandler), b.options.focusOnSelect === !0 && a(b.$slideTrack).children().off("click.slick", b.selectHandler), a(window).off("orientationchange.slick.slick-" + b.instanceUid, b.orientationChange), a(window).off("resize.slick.slick-" + b.instanceUid, b.resize), a("[draggable!=true]", b.$slideTrack).off("dragstart", b.preventDefault), a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition), a(document).off("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }, b.prototype.cleanUpSlideEvents = function () {
        var b = this;b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1));
    }, b.prototype.cleanUpRows = function () {
        var b,
            a = this;a.options.rows > 1 && (b = a.$slides.children().children(), b.removeAttr("style"), a.$slider.empty().append(b));
    }, b.prototype.clickHandler = function (a) {
        var b = this;b.shouldClick === !1 && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
    }, b.prototype.destroy = function (b) {
        var c = this;c.autoPlayClear(), c.touchObject = {}, c.cleanUpEvents(), a(".slick-cloned", c.$slider).detach(), c.$dots && c.$dots.remove(), c.$prevArrow && c.$prevArrow.length && (c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()), c.$nextArrow && c.$nextArrow.length && (c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()), c.$slides && (c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
            a(this).attr("style", a(this).data("originalStyling"));
        }), c.$slideTrack.children(this.options.slide).detach(), c.$slideTrack.detach(), c.$list.detach(), c.$slider.append(c.$slides)), c.cleanUpRows(), c.$slider.removeClass("slick-slider"), c.$slider.removeClass("slick-initialized"), c.$slider.removeClass("slick-dotted"), c.unslicked = !0, b || c.$slider.trigger("destroy", [c]);
    }, b.prototype.disableTransition = function (a) {
        var b = this,
            c = {};c[b.transitionType] = "", b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }, b.prototype.fadeSlide = function (a, b) {
        var c = this;c.cssTransitions === !1 ? (c.$slides.eq(a).css({ zIndex: c.options.zIndex }), c.$slides.eq(a).animate({ opacity: 1 }, c.options.speed, c.options.easing, b)) : (c.applyTransition(a), c.$slides.eq(a).css({ opacity: 1, zIndex: c.options.zIndex }), b && setTimeout(function () {
            c.disableTransition(a), b.call();
        }, c.options.speed));
    }, b.prototype.fadeSlideOut = function (a) {
        var b = this;b.cssTransitions === !1 ? b.$slides.eq(a).animate({ opacity: 0, zIndex: b.options.zIndex - 2 }, b.options.speed, b.options.easing) : (b.applyTransition(a), b.$slides.eq(a).css({ opacity: 0, zIndex: b.options.zIndex - 2 }));
    }, b.prototype.filterSlides = b.prototype.slickFilter = function (a) {
        var b = this;null !== a && (b.$slidesCache = b.$slides, b.unload(), b.$slideTrack.children(this.options.slide).detach(), b.$slidesCache.filter(a).appendTo(b.$slideTrack), b.reinit());
    }, b.prototype.focusHandler = function () {
        var b = this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (c) {
            c.stopImmediatePropagation();var d = a(this);setTimeout(function () {
                b.options.pauseOnFocus && (b.focussed = d.is(":focus"), b.autoPlay());
            }, 0);
        });
    }, b.prototype.getCurrent = b.prototype.slickCurrentSlide = function () {
        var a = this;return a.currentSlide;
    }, b.prototype.getDotCount = function () {
        var a = this,
            b = 0,
            c = 0,
            d = 0;if (a.options.infinite === !0) for (; b < a.slideCount;) {
            ++d, b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        } else if (a.options.centerMode === !0) d = a.slideCount;else if (a.options.asNavFor) for (; b < a.slideCount;) {
            ++d, b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        } else d = 1 + Math.ceil((a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll);return d - 1;
    }, b.prototype.getLeft = function (a) {
        var c,
            d,
            f,
            b = this,
            e = 0;return b.slideOffset = 0, d = b.$slides.first().outerHeight(!0), b.options.infinite === !0 ? (b.slideCount > b.options.slidesToShow && (b.slideOffset = b.slideWidth * b.options.slidesToShow * -1, e = d * b.options.slidesToShow * -1), b.slideCount % b.options.slidesToScroll !== 0 && a + b.options.slidesToScroll > b.slideCount && b.slideCount > b.options.slidesToShow && (a > b.slideCount ? (b.slideOffset = (b.options.slidesToShow - (a - b.slideCount)) * b.slideWidth * -1, e = (b.options.slidesToShow - (a - b.slideCount)) * d * -1) : (b.slideOffset = b.slideCount % b.options.slidesToScroll * b.slideWidth * -1, e = b.slideCount % b.options.slidesToScroll * d * -1))) : a + b.options.slidesToShow > b.slideCount && (b.slideOffset = (a + b.options.slidesToShow - b.slideCount) * b.slideWidth, e = (a + b.options.slidesToShow - b.slideCount) * d), b.slideCount <= b.options.slidesToShow && (b.slideOffset = 0, e = 0), b.options.centerMode === !0 && b.options.infinite === !0 ? b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2) - b.slideWidth : b.options.centerMode === !0 && (b.slideOffset = 0, b.slideOffset += b.slideWidth * Math.floor(b.options.slidesToShow / 2)), c = b.options.vertical === !1 ? a * b.slideWidth * -1 + b.slideOffset : a * d * -1 + e, b.options.variableWidth === !0 && (f = b.slideCount <= b.options.slidesToShow || b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow), c = b.options.rtl === !0 ? f[0] ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width()) : 0 : f[0] ? -1 * f[0].offsetLeft : 0, b.options.centerMode === !0 && (f = b.slideCount <= b.options.slidesToShow || b.options.infinite === !1 ? b.$slideTrack.children(".slick-slide").eq(a) : b.$slideTrack.children(".slick-slide").eq(a + b.options.slidesToShow + 1), c = b.options.rtl === !0 ? f[0] ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width()) : 0 : f[0] ? -1 * f[0].offsetLeft : 0, c += (b.$list.width() - f.outerWidth()) / 2)), c;
    }, b.prototype.getOption = b.prototype.slickGetOption = function (a) {
        var b = this;return b.options[a];
    }, b.prototype.getNavigableIndexes = function () {
        var e,
            a = this,
            b = 0,
            c = 0,
            d = [];for (a.options.infinite === !1 ? e = a.slideCount : (b = -1 * a.options.slidesToScroll, c = -1 * a.options.slidesToScroll, e = 2 * a.slideCount); e > b;) {
            d.push(b), b = c + a.options.slidesToScroll, c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow;
        }return d;
    }, b.prototype.getSlick = function () {
        return this;
    }, b.prototype.getSlideCount = function () {
        var c,
            d,
            e,
            b = this;return e = b.options.centerMode === !0 ? b.slideWidth * Math.floor(b.options.slidesToShow / 2) : 0, b.options.swipeToSlide === !0 ? (b.$slideTrack.find(".slick-slide").each(function (c, f) {
            return f.offsetLeft - e + a(f).outerWidth() / 2 > -1 * b.swipeLeft ? (d = f, !1) : void 0;
        }), c = Math.abs(a(d).attr("data-slick-index") - b.currentSlide) || 1) : b.options.slidesToScroll;
    }, b.prototype.goTo = b.prototype.slickGoTo = function (a, b) {
        var c = this;c.changeSlide({ data: { message: "index", index: parseInt(a) } }, b);
    }, b.prototype.init = function (b) {
        var c = this;a(c.$slider).hasClass("slick-initialized") || (a(c.$slider).addClass("slick-initialized"), c.buildRows(), c.buildOut(), c.setProps(), c.startLoad(), c.loadSlider(), c.initializeEvents(), c.updateArrows(), c.updateDots(), c.checkResponsive(!0), c.focusHandler()), b && c.$slider.trigger("init", [c]), c.options.accessibility === !0 && c.initADA(), c.options.autoplay && (c.paused = !1, c.autoPlay());
    }, b.prototype.initADA = function () {
        var b = this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }), b.$slideTrack.attr("role", "listbox"), b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
            a(this).attr({ role: "option", "aria-describedby": "slick-slide" + b.instanceUid + c });
        }), null !== b.$dots && b.$dots.attr("role", "tablist").find("li").each(function (c) {
            a(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + b.instanceUid + c, id: "slick-slide" + b.instanceUid + c });
        }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), b.activateADA();
    }, b.prototype.initArrowEvents = function () {
        var a = this;a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, a.changeSlide), a.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, a.changeSlide));
    }, b.prototype.initDotEvents = function () {
        var b = this;b.options.dots === !0 && b.slideCount > b.options.slidesToShow && a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide), b.options.dots === !0 && b.options.pauseOnDotsHover === !0 && a("li", b.$dots).on("mouseenter.slick", a.proxy(b.interrupt, b, !0)).on("mouseleave.slick", a.proxy(b.interrupt, b, !1));
    }, b.prototype.initSlideEvents = function () {
        var b = this;b.options.pauseOnHover && (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)));
    }, b.prototype.initializeEvents = function () {
        var b = this;b.initArrowEvents(), b.initDotEvents(), b.initSlideEvents(), b.$list.on("touchstart.slick mousedown.slick", { action: "start" }, b.swipeHandler), b.$list.on("touchmove.slick mousemove.slick", { action: "move" }, b.swipeHandler), b.$list.on("touchend.slick mouseup.slick", { action: "end" }, b.swipeHandler), b.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, b.swipeHandler), b.$list.on("click.slick", b.clickHandler), a(document).on(b.visibilityChange, a.proxy(b.visibility, b)), b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler), b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler), a(window).on("orientationchange.slick.slick-" + b.instanceUid, a.proxy(b.orientationChange, b)), a(window).on("resize.slick.slick-" + b.instanceUid, a.proxy(b.resize, b)), a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault), a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition), a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }, b.prototype.initUI = function () {
        var a = this;a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(), a.$nextArrow.show()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show();
    }, b.prototype.keyHandler = function (a) {
        var b = this;a.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === a.keyCode && b.options.accessibility === !0 ? b.changeSlide({ data: { message: b.options.rtl === !0 ? "next" : "previous" } }) : 39 === a.keyCode && b.options.accessibility === !0 && b.changeSlide({ data: { message: b.options.rtl === !0 ? "previous" : "next" } }));
    }, b.prototype.lazyLoad = function () {
        function g(c) {
            a("img[data-lazy]", c).each(function () {
                var c = a(this),
                    d = a(this).attr("data-lazy"),
                    e = document.createElement("img");e.onload = function () {
                    c.animate({ opacity: 0 }, 100, function () {
                        c.attr("src", d).animate({ opacity: 1 }, 200, function () {
                            c.removeAttr("data-lazy").removeClass("slick-loading");
                        }), b.$slider.trigger("lazyLoaded", [b, c, d]);
                    });
                }, e.onerror = function () {
                    c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), b.$slider.trigger("lazyLoadError", [b, c, d]);
                }, e.src = d;
            });
        }var c,
            d,
            e,
            f,
            b = this;b.options.centerMode === !0 ? b.options.infinite === !0 ? (e = b.currentSlide + (b.options.slidesToShow / 2 + 1), f = e + b.options.slidesToShow + 2) : (e = Math.max(0, b.currentSlide - (b.options.slidesToShow / 2 + 1)), f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide) : (e = b.options.infinite ? b.options.slidesToShow + b.currentSlide : b.currentSlide, f = Math.ceil(e + b.options.slidesToShow), b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)), c = b.$slider.find(".slick-slide").slice(e, f), g(c), b.slideCount <= b.options.slidesToShow ? (d = b.$slider.find(".slick-slide"), g(d)) : b.currentSlide >= b.slideCount - b.options.slidesToShow ? (d = b.$slider.find(".slick-cloned").slice(0, b.options.slidesToShow), g(d)) : 0 === b.currentSlide && (d = b.$slider.find(".slick-cloned").slice(-1 * b.options.slidesToShow), g(d));
    }, b.prototype.loadSlider = function () {
        var a = this;a.setPosition(), a.$slideTrack.css({ opacity: 1 }), a.$slider.removeClass("slick-loading"), a.initUI(), "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
    }, b.prototype.next = b.prototype.slickNext = function () {
        var a = this;a.changeSlide({ data: { message: "next" } });
    }, b.prototype.orientationChange = function () {
        var a = this;a.checkResponsive(), a.setPosition();
    }, b.prototype.pause = b.prototype.slickPause = function () {
        var a = this;a.autoPlayClear(), a.paused = !0;
    }, b.prototype.play = b.prototype.slickPlay = function () {
        var a = this;a.autoPlay(), a.options.autoplay = !0, a.paused = !1, a.focussed = !1, a.interrupted = !1;
    }, b.prototype.postSlide = function (a) {
        var b = this;b.unslicked || (b.$slider.trigger("afterChange", [b, a]), b.animating = !1, b.setPosition(), b.swipeLeft = null, b.options.autoplay && b.autoPlay(), b.options.accessibility === !0 && b.initADA());
    }, b.prototype.prev = b.prototype.slickPrev = function () {
        var a = this;a.changeSlide({ data: { message: "previous" } });
    }, b.prototype.preventDefault = function (a) {
        a.preventDefault();
    }, b.prototype.progressiveLazyLoad = function (b) {
        b = b || 1;var e,
            f,
            g,
            c = this,
            d = a("img[data-lazy]", c.$slider);d.length ? (e = d.first(), f = e.attr("data-lazy"), g = document.createElement("img"), g.onload = function () {
            e.attr("src", f).removeAttr("data-lazy").removeClass("slick-loading"), c.options.adaptiveHeight === !0 && c.setPosition(), c.$slider.trigger("lazyLoaded", [c, e, f]), c.progressiveLazyLoad();
        }, g.onerror = function () {
            3 > b ? setTimeout(function () {
                c.progressiveLazyLoad(b + 1);
            }, 500) : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), c.$slider.trigger("lazyLoadError", [c, e, f]), c.progressiveLazyLoad());
        }, g.src = f) : c.$slider.trigger("allImagesLoaded", [c]);
    }, b.prototype.refresh = function (b) {
        var d,
            e,
            c = this;e = c.slideCount - c.options.slidesToShow, !c.options.infinite && c.currentSlide > e && (c.currentSlide = e), c.slideCount <= c.options.slidesToShow && (c.currentSlide = 0), d = c.currentSlide, c.destroy(!0), a.extend(c, c.initials, { currentSlide: d }), c.init(), b || c.changeSlide({ data: { message: "index", index: d } }, !1);
    }, b.prototype.registerBreakpoints = function () {
        var c,
            d,
            e,
            b = this,
            f = b.options.responsive || null;if ("array" === a.type(f) && f.length) {
            b.respondTo = b.options.respondTo || "window";for (c in f) {
                if (e = b.breakpoints.length - 1, d = f[c].breakpoint, f.hasOwnProperty(c)) {
                    for (; e >= 0;) {
                        b.breakpoints[e] && b.breakpoints[e] === d && b.breakpoints.splice(e, 1), e--;
                    }b.breakpoints.push(d), b.breakpointSettings[d] = f[c].settings;
                }
            }b.breakpoints.sort(function (a, c) {
                return b.options.mobileFirst ? a - c : c - a;
            });
        }
    }, b.prototype.reinit = function () {
        var b = this;b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide"), b.slideCount = b.$slides.length, b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll), b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0), b.registerBreakpoints(), b.setProps(), b.setupInfinite(), b.buildArrows(), b.updateArrows(), b.initArrowEvents(), b.buildDots(), b.updateDots(), b.initDotEvents(), b.cleanUpSlideEvents(), b.initSlideEvents(), b.checkResponsive(!1, !0), b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler), b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0), b.setPosition(), b.focusHandler(), b.paused = !b.options.autoplay, b.autoPlay(), b.$slider.trigger("reInit", [b]);
    }, b.prototype.resize = function () {
        var b = this;a(window).width() !== b.windowWidth && (clearTimeout(b.windowDelay), b.windowDelay = window.setTimeout(function () {
            b.windowWidth = a(window).width(), b.checkResponsive(), b.unslicked || b.setPosition();
        }, 50));
    }, b.prototype.removeSlide = b.prototype.slickRemove = function (a, b, c) {
        var d = this;return "boolean" == typeof a ? (b = a, a = b === !0 ? 0 : d.slideCount - 1) : a = b === !0 ? --a : a, d.slideCount < 1 || 0 > a || a > d.slideCount - 1 ? !1 : (d.unload(), c === !0 ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(), d.$slides = d.$slideTrack.children(this.options.slide), d.$slideTrack.children(this.options.slide).detach(), d.$slideTrack.append(d.$slides), d.$slidesCache = d.$slides, void d.reinit());
    }, b.prototype.setCSS = function (a) {
        var d,
            e,
            b = this,
            c = {};b.options.rtl === !0 && (a = -a), d = "left" == b.positionProp ? Math.ceil(a) + "px" : "0px", e = "top" == b.positionProp ? Math.ceil(a) + "px" : "0px", c[b.positionProp] = a, b.transformsEnabled === !1 ? b.$slideTrack.css(c) : (c = {}, b.cssTransitions === !1 ? (c[b.animType] = "translate(" + d + ", " + e + ")", b.$slideTrack.css(c)) : (c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)", b.$slideTrack.css(c)));
    }, b.prototype.setDimensions = function () {
        var a = this;a.options.vertical === !1 ? a.options.centerMode === !0 && a.$list.css({ padding: "0px " + a.options.centerPadding }) : (a.$list.height(a.$slides.first().outerHeight(!0) * a.options.slidesToShow), a.options.centerMode === !0 && a.$list.css({ padding: a.options.centerPadding + " 0px" })), a.listWidth = a.$list.width(), a.listHeight = a.$list.height(), a.options.vertical === !1 && a.options.variableWidth === !1 ? (a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow), a.$slideTrack.width(Math.ceil(a.slideWidth * a.$slideTrack.children(".slick-slide").length))) : a.options.variableWidth === !0 ? a.$slideTrack.width(5e3 * a.slideCount) : (a.slideWidth = Math.ceil(a.listWidth), a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0) * a.$slideTrack.children(".slick-slide").length)));var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();a.options.variableWidth === !1 && a.$slideTrack.children(".slick-slide").width(a.slideWidth - b);
    }, b.prototype.setFade = function () {
        var c,
            b = this;b.$slides.each(function (d, e) {
            c = b.slideWidth * d * -1, b.options.rtl === !0 ? a(e).css({ position: "relative", right: c, top: 0, zIndex: b.options.zIndex - 2, opacity: 0 }) : a(e).css({ position: "relative", left: c, top: 0, zIndex: b.options.zIndex - 2, opacity: 0 });
        }), b.$slides.eq(b.currentSlide).css({ zIndex: b.options.zIndex - 1, opacity: 1 });
    }, b.prototype.setHeight = function () {
        var a = this;if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
            var b = a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height", b);
        }
    }, b.prototype.setOption = b.prototype.slickSetOption = function () {
        var c,
            d,
            e,
            f,
            h,
            b = this,
            g = !1;if ("object" === a.type(arguments[0]) ? (e = arguments[0], g = arguments[1], h = "multiple") : "string" === a.type(arguments[0]) && (e = arguments[0], f = arguments[1], g = arguments[2], "responsive" === arguments[0] && "array" === a.type(arguments[1]) ? h = "responsive" : "undefined" != typeof arguments[1] && (h = "single")), "single" === h) b.options[e] = f;else if ("multiple" === h) a.each(e, function (a, c) {
            b.options[a] = c;
        });else if ("responsive" === h) for (d in f) {
            if ("array" !== a.type(b.options.responsive)) b.options.responsive = [f[d]];else {
                for (c = b.options.responsive.length - 1; c >= 0;) {
                    b.options.responsive[c].breakpoint === f[d].breakpoint && b.options.responsive.splice(c, 1), c--;
                }b.options.responsive.push(f[d]);
            }
        }g && (b.unload(), b.reinit());
    }, b.prototype.setPosition = function () {
        var a = this;a.setDimensions(), a.setHeight(), a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(), a.$slider.trigger("setPosition", [a]);
    }, b.prototype.setProps = function () {
        var a = this,
            b = document.body.style;a.positionProp = a.options.vertical === !0 ? "top" : "left", "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"), (void 0 !== b.WebkitTransition || void 0 !== b.MozTransition || void 0 !== b.msTransition) && a.options.useCSS === !0 && (a.cssTransitions = !0), a.options.fade && ("number" == typeof a.options.zIndex ? a.options.zIndex < 3 && (a.options.zIndex = 3) : a.options.zIndex = a.defaults.zIndex), void 0 !== b.OTransform && (a.animType = "OTransform", a.transformType = "-o-transform", a.transitionType = "OTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.MozTransform && (a.animType = "MozTransform", a.transformType = "-moz-transform", a.transitionType = "MozTransition", void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)), void 0 !== b.webkitTransform && (a.animType = "webkitTransform", a.transformType = "-webkit-transform", a.transitionType = "webkitTransition", void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)), void 0 !== b.msTransform && (a.animType = "msTransform", a.transformType = "-ms-transform", a.transitionType = "msTransition", void 0 === b.msTransform && (a.animType = !1)), void 0 !== b.transform && a.animType !== !1 && (a.animType = "transform", a.transformType = "transform", a.transitionType = "transition"), a.transformsEnabled = a.options.useTransform && null !== a.animType && a.animType !== !1;
    }, b.prototype.setSlideClasses = function (a) {
        var c,
            d,
            e,
            f,
            b = this;d = b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), b.$slides.eq(a).addClass("slick-current"), b.options.centerMode === !0 ? (c = Math.floor(b.options.slidesToShow / 2), b.options.infinite === !0 && (a >= c && a <= b.slideCount - 1 - c ? b.$slides.slice(a - c, a + c + 1).addClass("slick-active").attr("aria-hidden", "false") : (e = b.options.slidesToShow + a, d.slice(e - c + 1, e + c + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === a ? d.eq(d.length - 1 - b.options.slidesToShow).addClass("slick-center") : a === b.slideCount - 1 && d.eq(b.options.slidesToShow).addClass("slick-center")), b.$slides.eq(a).addClass("slick-center")) : a >= 0 && a <= b.slideCount - b.options.slidesToShow ? b.$slides.slice(a, a + b.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : d.length <= b.options.slidesToShow ? d.addClass("slick-active").attr("aria-hidden", "false") : (f = b.slideCount % b.options.slidesToShow, e = b.options.infinite === !0 ? b.options.slidesToShow + a : a, b.options.slidesToShow == b.options.slidesToScroll && b.slideCount - a < b.options.slidesToShow ? d.slice(e - (b.options.slidesToShow - f), e + f).addClass("slick-active").attr("aria-hidden", "false") : d.slice(e, e + b.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === b.options.lazyLoad && b.lazyLoad();
    }, b.prototype.setupInfinite = function () {
        var c,
            d,
            e,
            b = this;if (b.options.fade === !0 && (b.options.centerMode = !1), b.options.infinite === !0 && b.options.fade === !1 && (d = null, b.slideCount > b.options.slidesToShow)) {
            for (e = b.options.centerMode === !0 ? b.options.slidesToShow + 1 : b.options.slidesToShow, c = b.slideCount; c > b.slideCount - e; c -= 1) {
                d = c - 1, a(b.$slides[d]).clone(!0).attr("id", "").attr("data-slick-index", d - b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");
            }for (c = 0; e > c; c += 1) {
                d = c, a(b.$slides[d]).clone(!0).attr("id", "").attr("data-slick-index", d + b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");
            }b.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                a(this).attr("id", "");
            });
        }
    }, b.prototype.interrupt = function (a) {
        var b = this;a || b.autoPlay(), b.interrupted = a;
    }, b.prototype.selectHandler = function (b) {
        var c = this,
            d = a(b.target).is(".slick-slide") ? a(b.target) : a(b.target).parents(".slick-slide"),
            e = parseInt(d.attr("data-slick-index"));return e || (e = 0), c.slideCount <= c.options.slidesToShow ? (c.setSlideClasses(e), void c.asNavFor(e)) : void c.slideHandler(e);
    }, b.prototype.slideHandler = function (a, b, c) {
        var d,
            e,
            f,
            g,
            j,
            h = null,
            i = this;return b = b || !1, i.animating === !0 && i.options.waitForAnimate === !0 || i.options.fade === !0 && i.currentSlide === a || i.slideCount <= i.options.slidesToShow ? void 0 : (b === !1 && i.asNavFor(a), d = a, h = i.getLeft(d), g = i.getLeft(i.currentSlide), i.currentLeft = null === i.swipeLeft ? g : i.swipeLeft, i.options.infinite === !1 && i.options.centerMode === !1 && (0 > a || a > i.getDotCount() * i.options.slidesToScroll) ? void (i.options.fade === !1 && (d = i.currentSlide, c !== !0 ? i.animateSlide(g, function () {
            i.postSlide(d);
        }) : i.postSlide(d))) : i.options.infinite === !1 && i.options.centerMode === !0 && (0 > a || a > i.slideCount - i.options.slidesToScroll) ? void (i.options.fade === !1 && (d = i.currentSlide, c !== !0 ? i.animateSlide(g, function () {
            i.postSlide(d);
        }) : i.postSlide(d))) : (i.options.autoplay && clearInterval(i.autoPlayTimer), e = 0 > d ? i.slideCount % i.options.slidesToScroll !== 0 ? i.slideCount - i.slideCount % i.options.slidesToScroll : i.slideCount + d : d >= i.slideCount ? i.slideCount % i.options.slidesToScroll !== 0 ? 0 : d - i.slideCount : d, i.animating = !0, i.$slider.trigger("beforeChange", [i, i.currentSlide, e]), f = i.currentSlide, i.currentSlide = e, i.setSlideClasses(i.currentSlide), i.options.asNavFor && (j = i.getNavTarget(), j = j.slick("getSlick"), j.slideCount <= j.options.slidesToShow && j.setSlideClasses(i.currentSlide)), i.updateDots(), i.updateArrows(), i.options.fade === !0 ? (c !== !0 ? (i.fadeSlideOut(f), i.fadeSlide(e, function () {
            i.postSlide(e);
        })) : i.postSlide(e), void i.animateHeight()) : void (c !== !0 ? i.animateSlide(h, function () {
            i.postSlide(e);
        }) : i.postSlide(e))));
    }, b.prototype.startLoad = function () {
        var a = this;a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(), a.$nextArrow.hide()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(), a.$slider.addClass("slick-loading");
    }, b.prototype.swipeDirection = function () {
        var a,
            b,
            c,
            d,
            e = this;return a = e.touchObject.startX - e.touchObject.curX, b = e.touchObject.startY - e.touchObject.curY, c = Math.atan2(b, a), d = Math.round(180 * c / Math.PI), 0 > d && (d = 360 - Math.abs(d)), 45 >= d && d >= 0 ? e.options.rtl === !1 ? "left" : "right" : 360 >= d && d >= 315 ? e.options.rtl === !1 ? "left" : "right" : d >= 135 && 225 >= d ? e.options.rtl === !1 ? "right" : "left" : e.options.verticalSwiping === !0 ? d >= 35 && 135 >= d ? "down" : "up" : "vertical";
    }, b.prototype.swipeEnd = function (a) {
        var c,
            d,
            b = this;if (b.dragging = !1, b.interrupted = !1, b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0, void 0 === b.touchObject.curX) return !1;if (b.touchObject.edgeHit === !0 && b.$slider.trigger("edge", [b, b.swipeDirection()]), b.touchObject.swipeLength >= b.touchObject.minSwipe) {
            switch (d = b.swipeDirection()) {case "left":case "down":
                    c = b.options.swipeToSlide ? b.checkNavigable(b.currentSlide + b.getSlideCount()) : b.currentSlide + b.getSlideCount(), b.currentDirection = 0;break;case "right":case "up":
                    c = b.options.swipeToSlide ? b.checkNavigable(b.currentSlide - b.getSlideCount()) : b.currentSlide - b.getSlideCount(), b.currentDirection = 1;}"vertical" != d && (b.slideHandler(c), b.touchObject = {}, b.$slider.trigger("swipe", [b, d]));
        } else b.touchObject.startX !== b.touchObject.curX && (b.slideHandler(b.currentSlide), b.touchObject = {});
    }, b.prototype.swipeHandler = function (a) {
        var b = this;if (!(b.options.swipe === !1 || "ontouchend" in document && b.options.swipe === !1 || b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))) switch (b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1, b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold, b.options.verticalSwiping === !0 && (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold), a.data.action) {case "start":
                b.swipeStart(a);break;case "move":
                b.swipeMove(a);break;case "end":
                b.swipeEnd(a);}
    }, b.prototype.swipeMove = function (a) {
        var d,
            e,
            f,
            g,
            h,
            b = this;return h = void 0 !== a.originalEvent ? a.originalEvent.touches : null, !b.dragging || h && 1 !== h.length ? !1 : (d = b.getLeft(b.currentSlide), b.touchObject.curX = void 0 !== h ? h[0].pageX : a.clientX, b.touchObject.curY = void 0 !== h ? h[0].pageY : a.clientY, b.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))), b.options.verticalSwiping === !0 && (b.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(b.touchObject.curY - b.touchObject.startY, 2)))), e = b.swipeDirection(), "vertical" !== e ? (void 0 !== a.originalEvent && b.touchObject.swipeLength > 4 && a.preventDefault(), g = (b.options.rtl === !1 ? 1 : -1) * (b.touchObject.curX > b.touchObject.startX ? 1 : -1), b.options.verticalSwiping === !0 && (g = b.touchObject.curY > b.touchObject.startY ? 1 : -1), f = b.touchObject.swipeLength, b.touchObject.edgeHit = !1, b.options.infinite === !1 && (0 === b.currentSlide && "right" === e || b.currentSlide >= b.getDotCount() && "left" === e) && (f = b.touchObject.swipeLength * b.options.edgeFriction, b.touchObject.edgeHit = !0), b.options.vertical === !1 ? b.swipeLeft = d + f * g : b.swipeLeft = d + f * (b.$list.height() / b.listWidth) * g, b.options.verticalSwiping === !0 && (b.swipeLeft = d + f * g), b.options.fade === !0 || b.options.touchMove === !1 ? !1 : b.animating === !0 ? (b.swipeLeft = null, !1) : void b.setCSS(b.swipeLeft)) : void 0);
    }, b.prototype.swipeStart = function (a) {
        var c,
            b = this;return b.interrupted = !0, 1 !== b.touchObject.fingerCount || b.slideCount <= b.options.slidesToShow ? (b.touchObject = {}, !1) : (void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (c = a.originalEvent.touches[0]), b.touchObject.startX = b.touchObject.curX = void 0 !== c ? c.pageX : a.clientX, b.touchObject.startY = b.touchObject.curY = void 0 !== c ? c.pageY : a.clientY, void (b.dragging = !0));
    }, b.prototype.unfilterSlides = b.prototype.slickUnfilter = function () {
        var a = this;null !== a.$slidesCache && (a.unload(), a.$slideTrack.children(this.options.slide).detach(), a.$slidesCache.appendTo(a.$slideTrack), a.reinit());
    }, b.prototype.unload = function () {
        var b = this;a(".slick-cloned", b.$slider).remove(), b.$dots && b.$dots.remove(), b.$prevArrow && b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.remove(), b.$nextArrow && b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.remove(), b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
    }, b.prototype.unslick = function (a) {
        var b = this;b.$slider.trigger("unslick", [b, a]), b.destroy();
    }, b.prototype.updateArrows = function () {
        var b,
            a = this;b = Math.floor(a.options.slidesToShow / 2), a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && !a.options.infinite && (a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === a.currentSlide ? (a.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : a.currentSlide >= a.slideCount - a.options.slidesToShow && a.options.centerMode === !1 ? (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : a.currentSlide >= a.slideCount - 1 && a.options.centerMode === !0 && (a.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
    }, b.prototype.updateDots = function () {
        var a = this;null !== a.$dots && (a.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), a.$dots.find("li").eq(Math.floor(a.currentSlide / a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"));
    }, b.prototype.visibility = function () {
        var a = this;a.options.autoplay && (document[a.hidden] ? a.interrupted = !0 : a.interrupted = !1);
    }, a.fn.slick = function () {
        var f,
            g,
            a = this,
            c = arguments[0],
            d = Array.prototype.slice.call(arguments, 1),
            e = a.length;for (f = 0; e > f; f++) {
            if ("object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) || "undefined" == typeof c ? a[f].slick = new b(a[f], c) : g = a[f].slick[c].apply(a[f].slick, d), "undefined" != typeof g) return g;
        }return a;
    };
});
/*! jQuery Migrate v1.2.1 | (c) 2005, 2013 jQuery Foundation, Inc. and other contributors | jquery.org/license */
jQuery.migrateMute === void 0 && (jQuery.migrateMute = !0), function (e, t, n) {
    function r(n) {
        var r = t.console;i[n] || (i[n] = !0, e.migrateWarnings.push(n), r && r.warn && !e.migrateMute && (r.warn("JQMIGRATE: " + n), e.migrateTrace && r.trace && r.trace()));
    }function a(t, a, i, o) {
        if (Object.defineProperty) try {
            return Object.defineProperty(t, a, { configurable: !0, enumerable: !0, get: function get() {
                    return r(o), i;
                }, set: function set(e) {
                    r(o), i = e;
                } }), n;
        } catch (s) {}e._definePropertyBroken = !0, t[a] = i;
    }var i = {};e.migrateWarnings = [], !e.migrateMute && t.console && t.console.log && t.console.log("JQMIGRATE: Logging is active"), e.migrateTrace === n && (e.migrateTrace = !0), e.migrateReset = function () {
        i = {}, e.migrateWarnings.length = 0;
    }, "BackCompat" === document.compatMode && r("jQuery is not compatible with Quirks Mode");var o = e("<input/>", { size: 1 }).attr("size") && e.attrFn,
        s = e.attr,
        u = e.attrHooks.value && e.attrHooks.value.get || function () {
        return null;
    },
        c = e.attrHooks.value && e.attrHooks.value.set || function () {
        return n;
    },
        l = /^(?:input|button)$/i,
        d = /^[238]$/,
        p = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
        f = /^(?:checked|selected)$/i;a(e, "attrFn", o || {}, "jQuery.attrFn is deprecated"), e.attr = function (t, a, i, u) {
        var c = a.toLowerCase(),
            g = t && t.nodeType;return u && (4 > s.length && r("jQuery.fn.attr( props, pass ) is deprecated"), t && !d.test(g) && (o ? a in o : e.isFunction(e.fn[a]))) ? e(t)[a](i) : ("type" === a && i !== n && l.test(t.nodeName) && t.parentNode && r("Can't change the 'type' of an input or button in IE 6/7/8"), !e.attrHooks[c] && p.test(c) && (e.attrHooks[c] = { get: function get(t, r) {
                var a,
                    i = e.prop(t, r);return i === !0 || "boolean" != typeof i && (a = t.getAttributeNode(r)) && a.nodeValue !== !1 ? r.toLowerCase() : n;
            }, set: function set(t, n, r) {
                var a;return n === !1 ? e.removeAttr(t, r) : (a = e.propFix[r] || r, a in t && (t[a] = !0), t.setAttribute(r, r.toLowerCase())), r;
            } }, f.test(c) && r("jQuery.fn.attr('" + c + "') may use property instead of attribute")), s.call(e, t, a, i));
    }, e.attrHooks.value = { get: function get(e, t) {
            var n = (e.nodeName || "").toLowerCase();return "button" === n ? u.apply(this, arguments) : ("input" !== n && "option" !== n && r("jQuery.fn.attr('value') no longer gets properties"), t in e ? e.value : null);
        }, set: function set(e, t) {
            var a = (e.nodeName || "").toLowerCase();return "button" === a ? c.apply(this, arguments) : ("input" !== a && "option" !== a && r("jQuery.fn.attr('value', val) no longer sets properties"), e.value = t, n);
        } };var g,
        h,
        v = e.fn.init,
        m = e.parseJSON,
        y = /^([^<]*)(<[\w\W]+>)([^>]*)$/;e.fn.init = function (t, n, a) {
        var i;return t && "string" == typeof t && !e.isPlainObject(n) && (i = y.exec(e.trim(t))) && i[0] && ("<" !== t.charAt(0) && r("$(html) HTML strings must start with '<' character"), i[3] && r("$(html) HTML text after last tag is ignored"), "#" === i[0].charAt(0) && (r("HTML string cannot start with a '#' character"), e.error("JQMIGRATE: Invalid selector string (XSS)")), n && n.context && (n = n.context), e.parseHTML) ? v.call(this, e.parseHTML(i[2], n, !0), n, a) : v.apply(this, arguments);
    }, e.fn.init.prototype = e.fn, e.parseJSON = function (e) {
        return e || null === e ? m.apply(this, arguments) : (r("jQuery.parseJSON requires a valid JSON string"), null);
    }, e.uaMatch = function (e) {
        e = e.toLowerCase();var t = /(chrome)[ \/]([\w.]+)/.exec(e) || /(webkit)[ \/]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(e) || /(msie) ([\w.]+)/.exec(e) || 0 > e.indexOf("compatible") && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e) || [];return { browser: t[1] || "", version: t[2] || "0" };
    }, e.browser || (g = e.uaMatch(navigator.userAgent), h = {}, g.browser && (h[g.browser] = !0, h.version = g.version), h.chrome ? h.webkit = !0 : h.webkit && (h.safari = !0), e.browser = h), a(e, "browser", e.browser, "jQuery.browser is deprecated"), e.sub = function () {
        function t(e, n) {
            return new t.fn.init(e, n);
        }e.extend(!0, t, this), t.superclass = this, t.fn = t.prototype = this(), t.fn.constructor = t, t.sub = this.sub, t.fn.init = function (r, a) {
            return a && a instanceof e && !(a instanceof t) && (a = t(a)), e.fn.init.call(this, r, a, n);
        }, t.fn.init.prototype = t.fn;var n = t(document);return r("jQuery.sub() is deprecated"), t;
    }, e.ajaxSetup({ converters: { "text json": e.parseJSON } });var b = e.fn.data;e.fn.data = function (t) {
        var a,
            i,
            o = this[0];return !o || "events" !== t || 1 !== arguments.length || (a = e.data(o, t), i = e._data(o, t), a !== n && a !== i || i === n) ? b.apply(this, arguments) : (r("Use of jQuery.fn.data('events') is deprecated"), i);
    };var j = /\/(java|ecma)script/i,
        w = e.fn.andSelf || e.fn.addBack;e.fn.andSelf = function () {
        return r("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()"), w.apply(this, arguments);
    }, e.clean || (e.clean = function (t, a, i, o) {
        a = a || document, a = !a.nodeType && a[0] || a, a = a.ownerDocument || a, r("jQuery.clean() is deprecated");var s,
            u,
            c,
            l,
            d = [];if (e.merge(d, e.buildFragment(t, a).childNodes), i) for (c = function c(e) {
            return !e.type || j.test(e.type) ? o ? o.push(e.parentNode ? e.parentNode.removeChild(e) : e) : i.appendChild(e) : n;
        }, s = 0; null != (u = d[s]); s++) {
            e.nodeName(u, "script") && c(u) || (i.appendChild(u), u.getElementsByTagName !== n && (l = e.grep(e.merge([], u.getElementsByTagName("script")), c), d.splice.apply(d, [s + 1, 0].concat(l)), s += l.length));
        }return d;
    });var Q = e.event.add,
        x = e.event.remove,
        k = e.event.trigger,
        N = e.fn.toggle,
        T = e.fn.live,
        M = e.fn.die,
        S = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
        C = RegExp("\\b(?:" + S + ")\\b"),
        H = /(?:^|\s)hover(\.\S+|)\b/,
        A = function A(t) {
        return "string" != typeof t || e.event.special.hover ? t : (H.test(t) && r("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'"), t && t.replace(H, "mouseenter$1 mouseleave$1"));
    };e.event.props && "attrChange" !== e.event.props[0] && e.event.props.unshift("attrChange", "attrName", "relatedNode", "srcElement"), e.event.dispatch && a(e.event, "handle", e.event.dispatch, "jQuery.event.handle is undocumented and deprecated"), e.event.add = function (e, t, n, a, i) {
        e !== document && C.test(t) && r("AJAX events should be attached to document: " + t), Q.call(this, e, A(t || ""), n, a, i);
    }, e.event.remove = function (e, t, n, r, a) {
        x.call(this, e, A(t) || "", n, r, a);
    }, e.fn.error = function () {
        var e = Array.prototype.slice.call(arguments, 0);return r("jQuery.fn.error() is deprecated"), e.splice(0, 0, "error"), arguments.length ? this.bind.apply(this, e) : (this.triggerHandler.apply(this, e), this);
    }, e.fn.toggle = function (t, n) {
        if (!e.isFunction(t) || !e.isFunction(n)) return N.apply(this, arguments);r("jQuery.fn.toggle(handler, handler...) is deprecated");var a = arguments,
            i = t.guid || e.guid++,
            o = 0,
            s = function s(n) {
            var r = (e._data(this, "lastToggle" + t.guid) || 0) % o;return e._data(this, "lastToggle" + t.guid, r + 1), n.preventDefault(), a[r].apply(this, arguments) || !1;
        };for (s.guid = i; a.length > o;) {
            a[o++].guid = i;
        }return this.click(s);
    }, e.fn.live = function (t, n, a) {
        return r("jQuery.fn.live() is deprecated"), T ? T.apply(this, arguments) : (e(this.context).on(t, this.selector, n, a), this);
    }, e.fn.die = function (t, n) {
        return r("jQuery.fn.die() is deprecated"), M ? M.apply(this, arguments) : (e(this.context).off(t, this.selector || "**", n), this);
    }, e.event.trigger = function (e, t, n, a) {
        return n || C.test(e) || r("Global events are undocumented and deprecated"), k.call(this, e, t, n || document, a);
    }, e.each(S.split("|"), function (t, n) {
        e.event.special[n] = { setup: function setup() {
                var t = this;return t !== document && (e.event.add(document, n + "." + e.guid, function () {
                    e.event.trigger(n, null, t, !0);
                }), e._data(this, n, e.guid++)), !1;
            }, teardown: function teardown() {
                return this !== document && e.event.remove(document, n + "." + e._data(this, n)), !1;
            } };
    });
}(jQuery, window);
/*! Magnific Popup - v1.0.0 - 2015-01-03
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function (a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("jquery") : window.jQuery || window.Zepto);
}(function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h = "Close",
        i = "BeforeClose",
        j = "AfterClose",
        k = "BeforeAppend",
        l = "MarkupParse",
        m = "Open",
        n = "Change",
        o = "mfp",
        p = "." + o,
        q = "mfp-ready",
        r = "mfp-removing",
        s = "mfp-prevent-close",
        t = function t() {},
        u = !!window.jQuery,
        v = a(window),
        w = function w(a, c) {
        b.ev.on(o + a + p, c);
    },
        x = function x(b, c, d, e) {
        var f = document.createElement("div");return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f;
    },
        y = function y(c, d) {
        b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));
    },
        z = function z(c) {
        return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn;
    },
        A = function A() {
        a.magnificPopup.instance || (b = new t(), b.init(), a.magnificPopup.instance = b);
    },
        B = function B() {
        var a = document.createElement("p").style,
            b = ["ms", "O", "Moz", "Webkit"];if (void 0 !== a.transition) return !0;for (; b.length;) {
            if (b.pop() + "Transition" in a) return !0;
        }return !1;
    };t.prototype = { constructor: t, init: function init() {
            var c = navigator.appVersion;b.isIE7 = -1 !== c.indexOf("MSIE 7."), b.isIE8 = -1 !== c.indexOf("MSIE 8."), b.isLowIE = b.isIE7 || b.isIE8, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {};
        }, open: function open(c) {
            var e;if (c.isObj === !1) {
                b.items = c.items.toArray(), b.index = 0;var g,
                    h = c.items;for (e = 0; e < h.length; e++) {
                    if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
                        b.index = e;break;
                    }
                }
            } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;if (b.isOpen) return void b.updateItemHTML();b.types = [], f = "", b.ev = c.mainEl && c.mainEl.length ? c.mainEl.eq(0) : d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function () {
                b.close();
            }), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function (a) {
                b._checkIfClose(a.target) && b.close();
            }), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));var i = a.magnificPopup.modules;for (e = 0; e < i.length; e++) {
                var j = i[e];j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b);
            }y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function (a, b, c, d) {
                c.close_replaceWith = z(d.type);
            }), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.wrap.css(b.fixedContentPos ? { overflow: b.st.overflowY, overflowX: "hidden", overflowY: b.st.overflowY } : { top: v.scrollTop(), position: "absolute" }), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({ height: d.height(), position: "absolute" }), b.st.enableEscapeKey && d.on("keyup" + p, function (a) {
                27 === a.keyCode && b.close();
            }), v.on("resize" + p, function () {
                b.updateSize();
            }), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);var k = b.wH = v.height(),
                n = {};if (b.fixedContentPos && b._hasScrollBar(k)) {
                var o = b._getScrollbarSize();o && (n.marginRight = o);
            }b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");var r = b.st.mainClass;return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function () {
                b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn);
            }, 16), b.isOpen = !0, b.updateSize(k), y(m), c;
        }, close: function close() {
            b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function () {
                b._close();
            }, b.st.removalDelay)) : b._close());
        }, _close: function _close() {
            y(h);var c = r + " " + q + " ";if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
                var e = { marginRight: "" };b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e);
            }d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j);
        }, updateSize: function updateSize(a) {
            if (b.isIOS) {
                var c = document.documentElement.clientWidth / window.innerWidth,
                    d = window.innerHeight * c;b.wrap.css("height", d), b.wH = d;
            } else b.wH = a || v.height();b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize");
        }, updateItemHTML: function updateItemHTML() {
            var c = b.items[b.index];b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));var d = c.type;if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
                var f = b.st[d] ? b.st[d].markup : !1;y("FirstMarkupParse", f), b.currTemplate[d] = f ? a(f) : !0;
            }e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange");
        }, appendContent: function appendContent(a, c) {
            b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content);
        }, parseEl: function parseEl(c) {
            var d,
                e = b.items[c];if (e.tagName ? e = { el: a(e) } : (d = e.type, e = { data: e, src: e.src }), e.el) {
                for (var f = b.types, g = 0; g < f.length; g++) {
                    if (e.el.hasClass("mfp-" + f[g])) {
                        d = f[g];break;
                    }
                }e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"));
            }return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c];
        }, addGroup: function addGroup(a, c) {
            var d = function d(_d) {
                _d.mfpEl = this, b._openClick(_d, a, c);
            };c || (c = {});var e = "click.magnificPopup";c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)));
        }, _openClick: function _openClick(c, d, e) {
            var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;if (f || 2 !== c.which && !c.ctrlKey && !c.metaKey) {
                var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;if (g) if (a.isFunction(g)) {
                    if (!g.call(b)) return !0;
                } else if (v.width() < g) return !0;c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e);
            }
        }, updateStatus: function updateStatus(a, d) {
            if (b.preloader) {
                c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);var e = { status: a, text: d };y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function (a) {
                    a.stopImmediatePropagation();
                }), b.container.addClass("mfp-s-" + a), c = a;
            }
        }, _checkIfClose: function _checkIfClose(c) {
            if (!a(c).hasClass(s)) {
                var d = b.st.closeOnContentClick,
                    e = b.st.closeOnBgClick;if (d && e) return !0;if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;if (c === b.content[0] || a.contains(b.content[0], c)) {
                    if (d) return !0;
                } else if (e && a.contains(document, c)) return !0;return !1;
            }
        }, _addClassToMFP: function _addClassToMFP(a) {
            b.bgOverlay.addClass(a), b.wrap.addClass(a);
        }, _removeClassFromMFP: function _removeClassFromMFP(a) {
            this.bgOverlay.removeClass(a), b.wrap.removeClass(a);
        }, _hasScrollBar: function _hasScrollBar(a) {
            return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height());
        }, _setFocus: function _setFocus() {
            (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
        }, _onFocusIn: function _onFocusIn(c) {
            return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1);
        }, _parseMarkup: function _parseMarkup(b, c, d) {
            var e;d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function (a, c) {
                if (void 0 === c || c === !1) return !0;if (e = a.split("_"), e.length > 1) {
                    var d = b.find(p + "-" + e[0]);if (d.length > 0) {
                        var f = e[1];"replaceWith" === f ? d[0] !== c[0] && d.replaceWith(c) : "img" === f ? d.is("img") ? d.attr("src", c) : d.replaceWith('<img src="' + c + '" class="' + d.attr("class") + '" />') : d.attr(e[1], c);
                    }
                } else b.find(p + "-" + a).html(c);
            });
        }, _getScrollbarSize: function _getScrollbarSize() {
            if (void 0 === b.scrollbarSize) {
                var a = document.createElement("div");a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a);
            }return b.scrollbarSize;
        } }, a.magnificPopup = { instance: null, proto: t.prototype, modules: [], open: function open(b, c) {
            return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b);
        }, close: function close() {
            return a.magnificPopup.instance && a.magnificPopup.instance.close();
        }, registerModule: function registerModule(b, c) {
            c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b);
        }, defaults: { disableOn: 0, key: null, midClick: !1, mainClass: "", preloader: !0, focus: "", closeOnContentClick: !1, closeOnBgClick: !0, closeBtnInside: !0, showCloseBtn: !0, enableEscapeKey: !0, modal: !1, alignTop: !1, removalDelay: 0, prependTo: null, fixedContentPos: "auto", fixedBgPos: "auto", overflowY: "auto", closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>', tClose: "Close (Esc)", tLoading: "Loading..." } }, a.fn.magnificPopup = function (c) {
        A();var d = a(this);if ("string" == typeof c) {
            if ("open" === c) {
                var e,
                    f = u ? d.data("magnificPopup") : d[0].magnificPopup,
                    g = parseInt(arguments[1], 10) || 0;f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({ mfpEl: e }, d, f);
            } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
        } else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);return d;
    };var C,
        D,
        E,
        F = "inline",
        G = function G() {
        E && (D.after(E.addClass(C)).detach(), E = null);
    };a.magnificPopup.registerModule(F, { options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" }, proto: { initInline: function initInline() {
                b.types.push(F), w(h + "." + F, function () {
                    G();
                });
            }, getInline: function getInline(c, d) {
                if (G(), c.src) {
                    var e = b.st.inline,
                        f = a(c.src);if (f.length) {
                        var g = f[0].parentNode;g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready");
                    } else b.updateStatus("error", e.tNotFound), f = a("<div>");return c.inlineElement = f, f;
                }return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d;
            } } });var H,
        I = "ajax",
        J = function J() {
        H && a(document.body).removeClass(H);
    },
        K = function K() {
        J(), b.req && b.req.abort();
    };a.magnificPopup.registerModule(I, { options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' }, proto: { initAjax: function initAjax() {
                b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K);
            }, getAjax: function getAjax(c) {
                H && a(document.body).addClass(H), b.updateStatus("loading");var d = a.extend({ url: c.src, success: function success(d, e, f) {
                        var g = { data: d, xhr: f };y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function () {
                            b.wrap.addClass(q);
                        }, 16), b.updateStatus("ready"), y("AjaxContentAdded");
                    }, error: function error() {
                        J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src));
                    } }, b.st.ajax.settings);return b.req = a.ajax(d), "";
            } } });var L,
        M = function M(c) {
        if (c.data && void 0 !== c.data.title) return c.data.title;var d = b.st.image.titleSrc;if (d) {
            if (a.isFunction(d)) return d.call(b, c);if (c.el) return c.el.attr(d) || "";
        }return "";
    };a.magnificPopup.registerModule("image", { options: { markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>', cursor: "mfp-zoom-out-cur", titleSrc: "title", verticalFit: !0, tError: '<a href="%url%">The image</a> could not be loaded.' }, proto: { initImage: function initImage() {
                var c = b.st.image,
                    d = ".image";b.types.push("image"), w(m + d, function () {
                    "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor);
                }), w(h + d, function () {
                    c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p);
                }), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage);
            }, resizeImage: function resizeImage() {
                var a = b.currItem;if (a && a.img && b.st.image.verticalFit) {
                    var c = 0;b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c);
                }
            }, _onImageHasSize: function _onImageHasSize(a) {
                a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1));
            }, findImageSize: function findImageSize(a) {
                var c = 0,
                    d = a.img[0],
                    e = function e(f) {
                    L && clearInterval(L), L = setInterval(function () {
                        return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)));
                    }, f);
                };e(1);
            }, getImage: function getImage(c, d) {
                var e = 0,
                    f = function f() {
                    c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()));
                },
                    g = function g() {
                    c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0);
                },
                    h = b.st.image,
                    i = d.find(".mfp-img");if (i.length) {
                    var j = document.createElement("img");j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1);
                }return b._parseMarkup(d, { title: M(c), img_replaceWith: c.img }, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d);
            } } });var N,
        O = function O() {
        return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N;
    };a.magnificPopup.registerModule("zoom", { options: { enabled: !1, easing: "ease-in-out", duration: 300, opener: function opener(a) {
                return a.is("img") ? a : a.find("img");
            } }, proto: { initZoom: function initZoom() {
                var a,
                    c = b.st.zoom,
                    d = ".zoom";if (c.enabled && b.supportsTransition) {
                    var e,
                        f,
                        g = c.duration,
                        j = function j(a) {
                        var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                            d = "all " + c.duration / 1e3 + "s " + c.easing,
                            e = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
                            f = "transition";return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b;
                    },
                        k = function k() {
                        b.content.css("visibility", "visible");
                    };w("BuildControls" + d, function () {
                        if (b._allowZoom()) {
                            if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function () {
                                f.css(b._getOffset(!0)), e = setTimeout(function () {
                                    k(), setTimeout(function () {
                                        f.remove(), a = f = null, y("ZoomAnimationEnded");
                                    }, 16);
                                }, g);
                            }, 16);
                        }
                    }), w(i + d, function () {
                        if (b._allowZoom()) {
                            if (clearTimeout(e), b.st.removalDelay = g, !a) {
                                if (a = b._getItemToZoom(), !a) return;f = j(a);
                            }f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function () {
                                f.css(b._getOffset());
                            }, 16);
                        }
                    }), w(h + d, function () {
                        b._allowZoom() && (k(), f && f.remove(), a = null);
                    });
                }
            }, _allowZoom: function _allowZoom() {
                return "image" === b.currItem.type;
            }, _getItemToZoom: function _getItemToZoom() {
                return b.currItem.hasSize ? b.currItem.img : !1;
            }, _getOffset: function _getOffset(c) {
                var d;d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);var e = d.offset(),
                    f = parseInt(d.css("padding-top"), 10),
                    g = parseInt(d.css("padding-bottom"), 10);e.top -= a(window).scrollTop() - f;var h = { width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f };return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h;
            } } });var P = "iframe",
        Q = "//about:blank",
        R = function R(a) {
        if (b.currTemplate[P]) {
            var c = b.currTemplate[P].find("iframe");c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"));
        }
    };a.magnificPopup.registerModule(P, { options: { markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>', srcAction: "iframe_src", patterns: { youtube: { index: "youtube.com", id: function id(src) {
                        var mt = src.match(/v=([^&]+)(&(.*))?/);if (mt) return mt[1] + '?' + mt[3];mt = src.match(/embed\/([^\?\/]+)(\?(.*))?/);if (mt) return mt[1] + '?' + mt[3];
                    }, src: "//www.youtube.com/embed/%id%&autoplay=1&rel=0" }, vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" }, gmaps: { index: "//maps.google.", src: "%id%&output=embed" } } }, proto: { initIframe: function initIframe() {
                b.types.push(P), w("BeforeChange", function (a, b, c) {
                    b !== c && (b === P ? R() : c === P && R(!0));
                }), w(h + "." + P, function () {
                    R();
                });
            }, getIframe: function getIframe(c, d) {
                var e = c.src,
                    f = b.st.iframe;a.each(f.patterns, function () {
                    return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0;
                });var g = {};return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d;
            } } });var S = function S(a) {
        var c = b.items.length;return a > c - 1 ? a - c : 0 > a ? c + a : a;
    },
        T = function T(a, b, c) {
        return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);
    };a.magnificPopup.registerModule("gallery", { options: { enabled: !1, arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', preload: [0, 2], navigateByImgClick: !0, arrows: !0, tPrev: "Previous (Left arrow key)", tNext: "Next (Right arrow key)", tCounter: "%curr% of %total%" }, proto: { initGallery: function initGallery() {
                var c = b.st.gallery,
                    e = ".mfp-gallery",
                    g = Boolean(a.fn.mfpFastClick);return b.direction = !0, c && c.enabled ? (f += " mfp-gallery", w(m + e, function () {
                    c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function () {
                        return b.items.length > 1 ? (b.next(), !1) : void 0;
                    }), d.on("keydown" + e, function (a) {
                        37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();
                    });
                }), w("UpdateStatus" + e, function (a, c) {
                    c.text && (c.text = T(c.text, b.currItem.index, b.items.length));
                }), w(l + e, function (a, d, e, f) {
                    var g = b.items.length;e.counter = g > 1 ? T(c.tCounter, f.index, g) : "";
                }), w("BuildControls" + e, function () {
                    if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                        var d = c.arrowMarkup,
                            e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s),
                            f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s),
                            h = g ? "mfpFastClick" : "click";e[h](function () {
                            b.prev();
                        }), f[h](function () {
                            b.next();
                        }), b.isIE7 && (x("b", e[0], !1, !0), x("a", e[0], !1, !0), x("b", f[0], !1, !0), x("a", f[0], !1, !0)), b.container.append(e.add(f));
                    }
                }), w(n + e, function () {
                    b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function () {
                        b.preloadNearbyImages(), b._preloadTimeout = null;
                    }, 16);
                }), void w(h + e, function () {
                    d.off(e), b.wrap.off("click" + e), b.arrowLeft && g && b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(), b.arrowRight = b.arrowLeft = null;
                })) : !1;
            }, next: function next() {
                b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML();
            }, prev: function prev() {
                b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML();
            }, goTo: function goTo(a) {
                b.direction = a >= b.index, b.index = a, b.updateItemHTML();
            }, preloadNearbyImages: function preloadNearbyImages() {
                var a,
                    c = b.st.gallery.preload,
                    d = Math.min(c[0], b.items.length),
                    e = Math.min(c[1], b.items.length);for (a = 1; a <= (b.direction ? e : d); a++) {
                    b._preloadItem(b.index + a);
                }for (a = 1; a <= (b.direction ? d : e); a++) {
                    b._preloadItem(b.index - a);
                }
            }, _preloadItem: function _preloadItem(c) {
                if (c = S(c), !b.items[c].preloaded) {
                    var d = b.items[c];d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function () {
                        d.hasSize = !0;
                    }).on("error.mfploader", function () {
                        d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d);
                    }).attr("src", d.src)), d.preloaded = !0;
                }
            } } });var U = "retina";a.magnificPopup.registerModule(U, { options: { replaceSrc: function replaceSrc(a) {
                return a.src.replace(/\.\w+$/, function (a) {
                    return "@2x" + a;
                });
            }, ratio: 1 }, proto: { initRetina: function initRetina() {
                if (window.devicePixelRatio > 1) {
                    var a = b.st.retina,
                        c = a.ratio;c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function (a, b) {
                        b.img.css({ "max-width": b.img[0].naturalWidth / c, width: "100%" });
                    }), w("ElementParse." + U, function (b, d) {
                        d.src = a.replaceSrc(d, c);
                    }));
                }
            } } }), function () {
        var b = 1e3,
            c = "ontouchstart" in window,
            d = function d() {
            v.off("touchmove" + f + " touchend" + f);
        },
            e = "mfpFastClick",
            f = "." + e;a.fn.mfpFastClick = function (e) {
            return a(this).each(function () {
                var g,
                    h = a(this);if (c) {
                    var i, j, k, l, m, n;h.on("touchstart" + f, function (a) {
                        l = !1, n = 1, m = a.originalEvent ? a.originalEvent.touches[0] : a.touches[0], j = m.clientX, k = m.clientY, v.on("touchmove" + f, function (a) {
                            m = a.originalEvent ? a.originalEvent.touches : a.touches, n = m.length, m = m[0], (Math.abs(m.clientX - j) > 10 || Math.abs(m.clientY - k) > 10) && (l = !0, d());
                        }).on("touchend" + f, function (a) {
                            d(), l || n > 1 || (g = !0, a.preventDefault(), clearTimeout(i), i = setTimeout(function () {
                                g = !1;
                            }, b), e());
                        });
                    });
                }h.on("click" + f, function () {
                    g || e();
                });
            });
        }, a.fn.destroyMfpFastClick = function () {
            a(this).off("touchstart" + f + " click" + f), c && v.off("touchmove" + f + " touchend" + f);
        };
    }(), A();
});
!function () {
    "use strict";
    function e(n) {
        return "undefined" == typeof this || Object.getPrototypeOf(this) !== e.prototype ? new e(n) : (O = this, O.version = "3.3.1", O.tools = new E(), O.isSupported() ? (O.tools.extend(O.defaults, n || {}), t(O.defaults), O.store = { elements: {}, containers: [] }, O.sequences = {}, O.history = [], O.uid = 0, O.initialized = !1) : "undefined" != typeof console && null !== console, O);
    }function t(e) {
        if (e && e.container) {
            if ("string" == typeof e.container) return window.document.documentElement.querySelector(e.container);if (O.tools.isNode(e.container)) return e.container;
        }return O.defaults.container;
    }function n(e, t) {
        return "string" == typeof e ? Array.prototype.slice.call(t.querySelectorAll(e)) : O.tools.isNode(e) ? [e] : O.tools.isNodeList(e) ? Array.prototype.slice.call(e) : [];
    }function i() {
        return ++O.uid;
    }function o(e, t, n) {
        t.container && (t.container = n), e.config ? e.config = O.tools.extendClone(e.config, t) : e.config = O.tools.extendClone(O.defaults, t), "top" === e.config.origin || "bottom" === e.config.origin ? e.config.axis = "Y" : e.config.axis = "X";
    }function r(e) {
        var t = window.getComputedStyle(e.domEl);e.styles || (e.styles = { transition: {}, transform: {}, computed: {} }, e.styles.inline = e.domEl.getAttribute("style") || "", e.styles.inline += "; visibility: visible; ", e.styles.computed.opacity = t.opacity, t.transition && "all 0s ease 0s" !== t.transition ? e.styles.computed.transition = t.transition + ", " : e.styles.computed.transition = ""), e.styles.transition.instant = s(e, 0), e.styles.transition.delayed = s(e, e.config.delay), e.styles.transform.initial = " -webkit-transform:", e.styles.transform.target = " -webkit-transform:", a(e), e.styles.transform.initial += "transform:", e.styles.transform.target += "transform:", a(e);
    }function s(e, t) {
        var n = e.config;return "-webkit-transition: " + e.styles.computed.transition + "-webkit-transform " + n.duration / 1e3 + "s " + n.easing + " " + t / 1e3 + "s, opacity " + n.duration / 1e3 + "s " + n.easing + " " + t / 1e3 + "s; transition: " + e.styles.computed.transition + "transform " + n.duration / 1e3 + "s " + n.easing + " " + t / 1e3 + "s, opacity " + n.duration / 1e3 + "s " + n.easing + " " + t / 1e3 + "s; ";
    }function a(e) {
        var t,
            n = e.config,
            i = e.styles.transform;t = "top" === n.origin || "left" === n.origin ? /^-/.test(n.distance) ? n.distance.substr(1) : "-" + n.distance : n.distance, parseInt(n.distance) && (i.initial += " translate" + n.axis + "(" + t + ")", i.target += " translate" + n.axis + "(0)"), n.scale && (i.initial += " scale(" + n.scale + ")", i.target += " scale(1)"), n.rotate.x && (i.initial += " rotateX(" + n.rotate.x + "deg)", i.target += " rotateX(0)"), n.rotate.y && (i.initial += " rotateY(" + n.rotate.y + "deg)", i.target += " rotateY(0)"), n.rotate.z && (i.initial += " rotateZ(" + n.rotate.z + "deg)", i.target += " rotateZ(0)"), i.initial += "; opacity: " + n.opacity + ";", i.target += "; opacity: " + e.styles.computed.opacity + ";";
    }function l(e) {
        var t = e.config.container;t && O.store.containers.indexOf(t) === -1 && O.store.containers.push(e.config.container), O.store.elements[e.id] = e;
    }function c(e, t, n) {
        var i = { target: e, config: t, interval: n };O.history.push(i);
    }function f() {
        if (O.isSupported()) {
            y();for (var e = 0; e < O.store.containers.length; e++) {
                O.store.containers[e].addEventListener("scroll", d), O.store.containers[e].addEventListener("resize", d);
            }O.initialized || (window.addEventListener("scroll", d), window.addEventListener("resize", d), O.initialized = !0);
        }return O;
    }function d() {
        T(y);
    }function u() {
        var e, t, n, i;O.tools.forOwn(O.sequences, function (o) {
            i = O.sequences[o], e = !1;for (var r = 0; r < i.elemIds.length; r++) {
                n = i.elemIds[r], t = O.store.elements[n], q(t) && !e && (e = !0);
            }i.active = e;
        });
    }function y() {
        var e, t;u(), O.tools.forOwn(O.store.elements, function (n) {
            t = O.store.elements[n], e = w(t), g(t) ? (t.config.beforeReveal(t.domEl), e ? t.domEl.setAttribute("style", t.styles.inline + t.styles.transform.target + t.styles.transition.delayed) : t.domEl.setAttribute("style", t.styles.inline + t.styles.transform.target + t.styles.transition.instant), p("reveal", t, e), t.revealing = !0, t.seen = !0, t.sequence && m(t, e)) : v(t) && (t.config.beforeReset(t.domEl), t.domEl.setAttribute("style", t.styles.inline + t.styles.transform.initial + t.styles.transition.instant), p("reset", t), t.revealing = !1);
        });
    }function m(e, t) {
        var n = 0,
            i = 0,
            o = O.sequences[e.sequence.id];o.blocked = !0, t && "onload" === e.config.useDelay && (i = e.config.delay), e.sequence.timer && (n = Math.abs(e.sequence.timer.started - new Date()), window.clearTimeout(e.sequence.timer)), e.sequence.timer = { started: new Date() }, e.sequence.timer.clock = window.setTimeout(function () {
            o.blocked = !1, e.sequence.timer = null, d();
        }, Math.abs(o.interval) + i - n);
    }function p(e, t, n) {
        var i = 0,
            o = 0,
            r = "after";switch (e) {case "reveal":
                o = t.config.duration, n && (o += t.config.delay), r += "Reveal";break;case "reset":
                o = t.config.duration, r += "Reset";}t.timer && (i = Math.abs(t.timer.started - new Date()), window.clearTimeout(t.timer.clock)), t.timer = { started: new Date() }, t.timer.clock = window.setTimeout(function () {
            t.config[r](t.domEl), t.timer = null;
        }, o - i);
    }function g(e) {
        if (e.sequence) {
            var t = O.sequences[e.sequence.id];return t.active && !t.blocked && !e.revealing && !e.disabled;
        }return q(e) && !e.revealing && !e.disabled;
    }function w(e) {
        var t = e.config.useDelay;return "always" === t || "onload" === t && !O.initialized || "once" === t && !e.seen;
    }function v(e) {
        if (e.sequence) {
            var t = O.sequences[e.sequence.id];return !t.active && e.config.reset && e.revealing && !e.disabled;
        }return !q(e) && e.config.reset && e.revealing && !e.disabled;
    }function b(e) {
        return { width: e.clientWidth, height: e.clientHeight };
    }function h(e) {
        if (e && e !== window.document.documentElement) {
            var t = x(e);return { x: e.scrollLeft + t.left, y: e.scrollTop + t.top };
        }return { x: window.pageXOffset, y: window.pageYOffset };
    }function x(e) {
        var t = 0,
            n = 0,
            i = e.offsetHeight,
            o = e.offsetWidth;do {
            isNaN(e.offsetTop) || (t += e.offsetTop), isNaN(e.offsetLeft) || (n += e.offsetLeft), e = e.offsetParent;
        } while (e);return { top: t, left: n, height: i, width: o };
    }function q(e) {
        function t() {
            var t = c + a * s,
                n = f + l * s,
                i = d - a * s,
                y = u - l * s,
                m = r.y + e.config.viewOffset.top,
                p = r.x + e.config.viewOffset.left,
                g = r.y - e.config.viewOffset.bottom + o.height,
                w = r.x - e.config.viewOffset.right + o.width;return t < g && i > m && n > p && y < w;
        }function n() {
            return "fixed" === window.getComputedStyle(e.domEl).position;
        }var i = x(e.domEl),
            o = b(e.config.container),
            r = h(e.config.container),
            s = e.config.viewFactor,
            a = i.height,
            l = i.width,
            c = i.top,
            f = i.left,
            d = c + a,
            u = f + l;return t() || n();
    }function E() {}var O, T;e.prototype.defaults = { origin: "bottom", distance: "20px", duration: 500, delay: 0, rotate: { x: 0, y: 0, z: 0 }, opacity: 0, scale: .9, easing: "cubic-bezier(0.6, 0.2, 0.1, 1)", container: window.document.documentElement, mobile: !0, reset: !1, useDelay: "always", viewFactor: .2, viewOffset: { top: 0, right: 0, bottom: 0, left: 0 }, beforeReveal: function beforeReveal(e) {}, afterReveal: function afterReveal(e) {}, beforeReset: function beforeReset(e) {}, afterReset: function afterReset(e) {} }, e.prototype.isSupported = function () {
        var e = document.documentElement.style;return "WebkitTransition" in e && "WebkitTransform" in e || "transition" in e && "transform" in e;
    }, e.prototype.reveal = function (e, s, a, d) {
        var u, y, m, p, g, w;if (void 0 !== s && "number" == typeof s ? (a = s, s = {}) : void 0 !== s && null !== s || (s = {}), u = t(s), y = n(e, u), !y.length) return O;a && "number" == typeof a && (w = i(), g = O.sequences[w] = { id: w, interval: a, elemIds: [], active: !1 });for (var v = 0; v < y.length; v++) {
            p = y[v].getAttribute("data-sr-id"), p ? m = O.store.elements[p] : (m = { id: i(), domEl: y[v], seen: !1, revealing: !1 }, m.domEl.setAttribute("data-sr-id", m.id)), g && (m.sequence = { id: g.id, index: g.elemIds.length }, g.elemIds.push(m.id)), o(m, s, u), r(m), l(m), O.tools.isMobile() && !m.config.mobile || !O.isSupported() ? (m.domEl.setAttribute("style", m.styles.inline), m.disabled = !0) : m.revealing || m.domEl.setAttribute("style", m.styles.inline + m.styles.transform.initial);
        }return !d && O.isSupported() && (c(e, s, a), O.initTimeout && window.clearTimeout(O.initTimeout), O.initTimeout = window.setTimeout(f, 0)), O;
    }, e.prototype.sync = function () {
        if (O.history.length && O.isSupported()) {
            for (var e = 0; e < O.history.length; e++) {
                var t = O.history[e];O.reveal(t.target, t.config, t.interval, !0);
            }f();
        }return O;
    }, E.prototype.isObject = function (e) {
        return null !== e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.constructor === Object;
    }, E.prototype.isNode = function (e) {
        return "object" == _typeof(window.Node) ? e instanceof window.Node : e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
    }, E.prototype.isNodeList = function (e) {
        var t = Object.prototype.toString.call(e),
            n = /^\[object (HTMLCollection|NodeList|Object)\]$/;return "object" == _typeof(window.NodeList) ? e instanceof window.NodeList : e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && n.test(t) && "number" == typeof e.length && (0 === e.length || this.isNode(e[0]));
    }, E.prototype.forOwn = function (e, t) {
        if (!this.isObject(e)) throw new TypeError('Expected "object", but received "' + (typeof e === "undefined" ? "undefined" : _typeof(e)) + '".');for (var n in e) {
            e.hasOwnProperty(n) && t(n);
        }
    }, E.prototype.extend = function (e, t) {
        return this.forOwn(t, function (n) {
            this.isObject(t[n]) ? (e[n] && this.isObject(e[n]) || (e[n] = {}), this.extend(e[n], t[n])) : e[n] = t[n];
        }.bind(this)), e;
    }, E.prototype.extendClone = function (e, t) {
        return this.extend(this.extend({}, e), t);
    }, E.prototype.isMobile = function () {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        );
    }, T = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (e) {
        window.setTimeout(e, 1e3 / 60);
    }, "function" == typeof define && "object" == _typeof(define.amd) && define.amd ? define(function () {
        return e;
    }) : "undefined" != typeof module && module.exports ? module.exports = e : window.ScrollReveal = e;
}();
(function (global) {
    if (global.rlModule) {
        console.log("rlModule is defined!");
        return;
    }
    global.rlModule = function () {
        var _module = {};
        _module.grid = function () {
            if ($(".rl-grid").length != 0) {
                grid();
            }

            function grid() {
                try {
                    $(".rl-grid").each(function (index, obj) {
                        if ($(obj).find(".flex-item").length == 0) {
                            var wrapFlexItem = function wrapFlexItem(obj) {

                                $(obj).children().filter(function (index, items) {
                                    if ($(obj).find(".rl-flex-space").length == 0) {
                                        if (index < item / 2) {
                                            return items;
                                        }
                                    } else {
                                        if (index < (2 * item - 1) / 2) {
                                            return items;
                                        }
                                    }
                                }).wrapAll("<div style='width:100%' class='wrap1 rl-flex-wrap'></div>");

                                $(obj).find(".wrap1").children().each(function (index, items) {
                                    var length = $(obj).find(".wrap1").children().length;
                                    if (length - 1 == index && $(items).hasClass("rl-flex-space") == true) {
                                        $(items).remove();
                                    }
                                });

                                $(obj).children().filter(function (index, items) {
                                    if ($(items).hasClass("wrap1") == false) {
                                        return items;
                                    }
                                }).wrapAll("<div style='width:100%' class='wrap2 rl-justify-content-center rl-row-top-20 rl-flex-wrap'></div>");
                                $(obj).find(".wrap2").children().each(function (index, items) {
                                    if (index == 0 && $(items).hasClass("rl-flex-space") == true) {
                                        $(items).remove();
                                    }
                                });
                            };

                            var addSpace = function addSpace(obj) {
                                if (spaceFlex != null) {
                                    $(obj).find(".flex-item").each(function (index, items) {
                                        if (item - 1 != index) {
                                            if ($(items).data("flex-order") != null) {
                                                $(items).after("<div class='rl-flex-space' style='order:" + $(items).data("flex-order") + " ; flex:" + spaceFlex + " 1 0%;'></div>");
                                            } else {
                                                $(items).after("<div class='rl-flex-space' style='order:" + index + " ; flex:" + spaceFlex + " 1 0%;'></div>");
                                            }
                                        }
                                    });
                                } else if (space != null) {
                                    $(obj).find(".flex-item").each(function (index, items) {
                                        if (item - 1 != index) {
                                            if ($(items).data("flex-order") != null) {
                                                $(items).after("<div class='rl-flex-space' style='order:" + $(items).data("flex-order") + " ; width:" + space + "px;'></div>");
                                            } else {
                                                $(items).after("<div class='rl-flex-space' style='order:" + index + " ; width:" + space + "px;'></div>");
                                            }
                                        }
                                    });
                                } else {
                                    $(obj).find(".flex-item").each(function (index, items) {
                                        if (item - 1 != index) {
                                            if ($(items).data("flex-order") != null) {
                                                $(items).after("<div class='rl-flex-space' style='order:" + $(items).data("flex-order") + "'></div>");
                                            } else {
                                                $(items).after("<div class='rl-flex-space' style='order:" + index + "'></div>");
                                            }
                                        }
                                    });
                                }
                            };

                            var isReverse = $(obj).data("flex-reverse") == "1";
                            var layout = $(obj).data("flex-layout").split(",");
                            var space = $(obj).data("flex-space-px");
                            var spaceFlex = $(obj).data("flex-space");
                            var initWindowWidth = window.innerWidth;
                            var IsResize = false;

                            // 將div逆排列
                            if (isReverse) {
                                $(obj).css("flex-direction", "row-reverse");
                            }

                            // 分配寬度
                            for (var i = 0; i < layout.length; i++) {
                                var child = $(obj).children()[i];
                                if (child) {
                                    if ($(child).data("flex-order") != null) {
                                        $(child).css("flex", layout[i]).css("order", $(child).data("flex-order")).addClass("flex-item");
                                    } else {
                                        $(child).css("flex", layout[i]).css("order", i).addClass("flex-item");
                                    }
                                }
                            }

                            // 找出所有 flex-item
                            var item = $(obj).find(".flex-item").length;

                            // 產生間距
                            if ($(obj).find(".rl-flex-space").length == 0) {
                                addSpace(obj);
                            }

                            // 如果開啟時畫面小於991px,將flex-item分行
                            if (item >= 4) {
                                //沒有full-width的時候且 開啟畫面時小於991px
                                if ($(obj).hasClass('full-width') != true && IsResize == false && initWindowWidth < 991) {
                                    wrapFlexItem(obj);
                                    IsResize = true;
                                } else if (IsResize == false && initWindowWidth < 991 && initWindowWidth > 767) {
                                    wrapFlexItem(obj);
                                    IsResize = true;
                                }
                            }

                            // 當 window 縮放時
                            $(window).resize(function () {
                                var windowSize = window.innerWidth;
                                if (item >= 4) {
                                    //當數量是4個以上的時候

                                    if ($(obj).hasClass('full-width') && windowSize <= 767 && IsResize == true) {
                                        //  當window在767以下,且分行過
                                        $(obj).find(".wrap1").children().unwrap();
                                        $(obj).find(".wrap2").children().unwrap();
                                        $(obj).find(".wrap2").removeClass("rl-row-top-20");

                                        $(obj).find(".rl-flex-space").remove();

                                        if ($(obj).find(".rl-flex-space").length == 0) {
                                            addSpace(obj);
                                        }
                                        IsResize = false;
                                    } else if (windowSize > 767 && windowSize <= 991) {
                                        //當window在767以上,991以下
                                        if (IsResize == false) {
                                            //沒有分行過
                                            if ($(obj).find(".rl-flex-space").length == 0) {
                                                addSpace(obj);
                                            }
                                            $(obj).find(".wrap2").addClass("rl-row-top-20");wrapFlexItem(obj);
                                            IsResize = true;
                                        }
                                    } else if (windowSize > 991) {
                                        // 當window在991以上
                                        if (IsResize == true) {
                                            $(obj).find(".wrap1").children().unwrap();
                                            $(obj).find(".wrap2").children().unwrap();
                                            $(obj).find(".rl-flex-space").remove();

                                            if ($(obj).find(".rl-flex-space").length == 0) {
                                                addSpace(obj);
                                            }
                                            IsResize = false;
                                        }
                                    }
                                } else {
                                    //當數量不足4個的時候
                                    if (windowSize > 767 && IsResize == true) {
                                        if ($(obj).find(".rl-flex-space").length == 0) {
                                            addSpace(obj);
                                        }
                                        IsResize = false;
                                    } else if (windowSize < 576 && IsResize == false) {
                                        IsResize = true;
                                    }
                                }
                            });
                        }
                    });
                } catch (e) {
                    console.log(e);
                }
            }
        };

        _module.ready = $(document).ready(function () {
            popupVideo(".rl-popup-video");
            popupImg(".rl-popup-img");

            _module.grid();

            function popupVideo(videoId) {
                $(videoId).magnificPopup({
                    type: "iframe",
                    tLoading: "Loading image #%curr%...",
                    mainClass: "mfp-img-mobile"
                });
            }
            function popupImg(target) {
                $(target).magnificPopup({
                    type: 'image',
                    closeOnContentClick: true,
                    mainClass: 'mfp-img-mobile',
                    image: {
                        verticalFit: true
                    }
                });
            }

            $(".rl-slide").slick({
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: true,
                dots: true,
                infinite: true
            });
        });

        return _module;
    }();
})(window);

(function (global) {
    if (global.rlModule.rlBannerModule) {
        console.log('rlBannerModule is already defined!');
        return;
    }
    global.rlModule.rlBannerModule = function () {
        var _module = {};
        var scriptPath = { contentPageJS: "/includes/script/modules/ContentPage.js" };

        _module.ready = $(document).ready(function () {
            rlModule.rlBannerModule.intialBannerTemplate();
        });

        _module.intialBannerTemplate = function () {
            var windowSize = window.innerWidth;

            if ($("._fetchPID").length > 0) {
                loadScript();
            }

            setPromoLabelColor();
            addPackIncludeListImage();

            $(window).on('load resize', function () {
                windowSize = window.innerWidth;
                if (windowSize <= 767) {
                    setFontSize(767, 1, windowSize);
                    setImageSize(767, 0.8, windowSize);
                } else {
                    setFontSize(1920, 1, windowSize);
                    setImageSize(1920, 1, windowSize);
                }
                setBannerHeightInMobileSize(windowSize);
                resetRowWidthWithLabel(windowSize);
            });
        };

        var setBannerHeightInMobileSize = function setBannerHeightInMobileSize(windowSize) {
            try {
                $(".rl-banner").each(function (index, obj) {
                    var settings;
                    var height;
                    var backgroundColor;
                    var ratio = 0;

                    if ($(obj).data("mobile-setting") != null) {
                        settings = $(obj).data("mobile-setting").toString().split(',');
                        height = settings[0];
                        backgroundColor = settings[1];

                        if (windowSize <= 767) {
                            $(obj).css({
                                "height": height / 767 * 100 + "vw",
                                "background-color": backgroundColor
                            });
                        } else {
                            $(obj).css({
                                "height": ""
                            });
                        }
                    }
                });
            } catch (e) {
                console.log(e);
            }
        };

        var resetRowWidthWithLabel = function resetRowWidthWithLabel(windowSize) {
            $(".rl-banner").find(".rl-promo-label").each(function (index, obj) {
                var target = $(obj).parent(".rl-banner").find(".rl-row-1440.rl-3x3");
                if (windowSize > 767) {
                    target.css("margin", "0 calc(12.1% + 15px)");
                } else {
                    target.css("margin", "0 15px");
                }
            });
        };

        var setPromoLabelColor = function setPromoLabelColor() {
            $(".rl-promo-label.type-triangle").each(function (index, obj) {
                var color = $(obj).data("label-color");
                if (color != null) {
                    if ($(obj).hasClass("position-right")) {
                        $(obj).css({
                            "border-color": 'transparent' + " " + color + " " + 'transparent transparent'
                        });
                    } else {
                        $(obj).css({ "border-color": color + ' ' + 'transparent transparent' });
                    }
                }
            });
        };

        var addPackIncludeListImage = function addPackIncludeListImage() {
            $(".rl-banner .rl-banner-packinclude").find(".type-image").each(function (index, obj) {
                var imageUrl = $(obj).data("list-image");
                $(obj).find("li").prepend("<img src='" + imageUrl + "'>");
            });
        };

        var setImageSize = function setImageSize(viewWidth, ratio, windowSize) {
            $(".rl-banner .rl-3x3").find("img").each(function (index, obj) {
                if ($(obj).hasClass("main-title") && windowSize <= 767) {
                    $(obj).css("width", "");
                } else {
                    var imgWidth;
                    var theImage = new Image();
                    theImage.src = $(obj).attr("src");
                    $(theImage).on('load', function () {
                        imgWidth = theImage.width;
                        $(obj).css("width", imgWidth * ratio / viewWidth * 100 + "vw");
                    });
                };
            });
        };

        var setFontSize = function setFontSize(viewWidth, ratio, windowSize) {
            try {
                $(".rl-banner .rl-3x3").find(".data_font_size").each(function (index, obj) {
                    if ($(obj).data("font-size") != null) {
                        var fontSizeArray = $(obj).data("font-size").toString().split(',');
                        var fontSizeSetting;

                        if (fontSizeArray.length > 0 && fontSizeArray.length != 1) {
                            if (windowSize <= 767) {
                                fontSizeSetting = parseInt(fontSizeArray[0]);
                                $(obj).css("font-size", fontSizeSetting * ratio / viewWidth * 100 + "vw");
                            } else {
                                fontSizeSetting = parseInt(fontSizeArray[1]);
                                $(obj).css("font-size", fontSizeSetting * ratio / viewWidth * 100 + "vw");
                            }
                        } else if (fontSizeArray.length > 0 && fontSizeArray.length == 1) {
                            fontSizeSetting = parseInt(fontSizeArray[0]);
                            $(obj).css("font-size", fontSizeSetting * ratio / 1920 * 100 + "vw");
                        }

                        var currentFontSize = parseInt($(obj).css('font-size').replace('px', ''));

                        if ($(obj).data("keep-scale") == 1) {
                            if (currentFontSize <= 12) {
                                var scale = fontSizeSetting * windowSize / viewWidth / 12;
                                $(obj).css({
                                    '-webkit-transform': 'scale(' + scale + ')',
                                    '-ms-transform': 'scale(' + scale + ')',
                                    'transform': 'scale(' + scale + ')',
                                    '-webkit-transform-origin': 'left top',
                                    '-ms-transform-origin': 'left top',
                                    'transform-origin': 'left top'
                                });
                            } else {
                                $(obj).css({
                                    '-webkit-transform': '',
                                    '-ms-transform': '',
                                    'transform': '',
                                    '-webkit-transform-origin': '',
                                    '-ms-transform-origin': '',
                                    'transform-origin': ''
                                });
                            }
                        }
                    }
                });
            } catch (e) {
                console.log(e);
            }
        };

        var loadScript = function loadScript() {
            $.getScript(scriptPath.contentPageJS).then(function () {}).fail(function () {
                console.log('load js fail.');
            });
        };

        return _module;
    }();
})(window);

(function (global) {
    if (global.rlModule.rlPackModule) {
        console.log('rlPackModule is defined!');
        return;
    }

    global.rlModule.rlPackModule = function () {
        var _module = {};

        var _rlServerConfigPath = '/includes/script/modules/rlServerConfig.js';
        var _requiredFilePaths = ['/includes/script/plugin/lz-string/lz-string.min.js', '/includes/script/modules/RLGlobal_Variable.js'];

        var _productdesc = {};
        var _productprice = {};

        var pageType = {
            "ic": 0,
            "ct": 1,
            "aud": 2,
            "cta": 3,
            "cc": 4
        };

        var modelPolygonSizeEnum = {
            LOW: 1,
            MID: 2,
            HIGH: 3
        };

        var textureResolutionEnum = {
            LOW: 1,
            MID: 2,
            HIGH: 3
        };

        var iconListTypeEnum = {
            SPEC: 0,
            ATTRIBUTE: 1
        };

        var displayMessageTypeForDiscontinuedContentEnum = {
            SHOW_DEFAULT_MESSAGE: 0,
            SHOW_PROMOTION: 1,
            HIDDEN: 2
        };

        var urlDomain = "https://www.reallusion.com/";
        var websiteName = "contentstore/";

        var textInfo = {};

        var pageInfoData = {};

        var apiUrl = {
            wishList: "ContentData/v2/User/WishList/",
            detailInfo: "ContentData/v2/Pack/DetailInfo"
        };

        $(function () {
            _productdesc = $("._productdesc");
            _productprice = $("._productprice");
            var _contentPid = $(".rl-contentpackprice[data-content-pid]");
            if (_productdesc.length > 0 || _productprice.length > 0 && _contentPid.length == 0) {
                _module.bindPackInfo();
            }
        });

        var shiftPriceAreaWhenScroll = function shiftPriceAreaWhenScroll() {
            if (_productdesc.length <= 0) {
                return;
            }

            var timeoutId = void 0;

            function shiftPriceArea() {
                //set _productprice width
                _productprice.find(".contentpack-info").addClass('contentpack-info--on-main-banner');
                var positionOfShiftPriceArea = _productdesc.offset().top - $(window).outerHeight(true);
                if (window.innerWidth > 767 && $(global).scrollTop() >= positionOfShiftPriceArea) {
                    _productdesc.find('._product-price').append($('.rl-contentpackprice'));

                    //set _productdesc sticky top
                    var topnavHeight = $('#topnavarea').height() || 60;
                    _productdesc.find("._productprice").css({ 'top': topnavHeight + 18 + "px" });
                    //remove _productprice class(width in desc is wider than in banner)
                    _productprice.find(".contentpack-info").removeClass('contentpack-info--on-main-banner');
                } else if ($('._product-price .rl-contentpackprice').length > 0) {
                    _productdesc.find(".rl-contentpackprice").insertAfter(".product-price-flag");
                }
            }
            //inset flag for insert price　use
            $('<div class="product-price-flag"></div>').insertBefore($('.rl-contentpackprice'));

            shiftPriceArea();
            $(global).on('scroll', function () {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(shiftPriceArea, 100);
            });
        };

        //get url param
        var getURLParameter = function getURLParameter(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };

        var deleteWishList = function deleteWishList(contentID) {
            return $.ajax({
                xhrFields: {
                    withCredentials: true
                },
                type: "DELETE",
                url: rlServerURL.API + apiUrl.wishList,
                data: JSON.stringify({ 'contentIDs': [contentID] }),
                headers: {
                    "Content-Type": "application/json"
                }
            });
        };

        var addWishList = function addWishList(contentID) {
            return $.ajax({
                xhrFields: {
                    withCredentials: true
                },
                type: "POST",
                url: rlServerURL.API + apiUrl.wishList,
                data: JSON.stringify({ contentID: contentID }),
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Compress-Output": "false"
                }
            });
        };

        var setWishListIconState = function setWishListIconState(active) {
            if (active) {
                document.querySelectorAll('.wishlist-icon').forEach(function (element) {
                    element.classList.add('active');
                    var parentElement = element.closest('.svg-icon-wrapper');
                    if (parentElement) {
                        parentElement.setAttribute('title', 'Delete from Wishlist');
                    }
                });
            } else {
                document.querySelectorAll('.wishlist-icon').forEach(function (element) {
                    element.classList.remove('active');
                    var parentElement = element.closest('.svg-icon-wrapper');
                    if (parentElement) {
                        parentElement.setAttribute('title', 'Add to Wishlist');
                    }
                });
            }
        };

        _module.toggleWishListButton = function () {
            if (!rlTopNav) {
                return;
            }

            if (rlTopNav.isLogin) {
                if (pageInfoData.CSItem.InWishList) {
                    deleteWishList(pageInfoData.CSItem.ContentID).then(function (response) {
                        if (response.ReturnCode == RLReturnCode.OperateSuccess.value) {
                            pageInfoData.CSItem.InWishList = false;
                            setWishListIconState(pageInfoData.CSItem.InWishList);
                            rlTopNav.updateMenuWishListNumber();
                        }
                    });
                } else {
                    addWishList(pageInfoData.CSItem.ContentID).then(function (response) {
                        if (response.ReturnCode == RLReturnCode.OperateSuccess.value) {
                            pageInfoData.CSItem.InWishList = true;
                            setWishListIconState(pageInfoData.CSItem.InWishList);
                            rlTopNav.updateMenuWishListNumber();
                        }
                    });
                }
            } else {
                rlTopNav.login();
            }
        };

        _module.popupShareDialog = function () {
            $.magnificPopup.open({
                items: {
                    src: "#share-panel",
                    type: 'inline'
                }
            });
        };

        _module.bindPackInfo = function (data) {
            _productdesc = $("._productdesc");
            _productprice = $("._productprice");

            function renderLayout(response) {
                var packinfo = response;
                if (packinfo.ReturnCode == RLReturnCode.OperateSuccess.value) {
                    pageInfoData = packinfo.ReturnData;

                    textInfo = _module.getRequiredVersionAndBuyButtonText({
                        MKPInfo: pageInfoData.CSItem.MKPInfo,
                        RequiredVersions: pageInfoData.RequiredVersions
                    });

                    if (_productprice.length > 0) {
                        renderProductPriceUI("/includes/rl-modules/wpt/v1/rlcontentpackprice-tpl.html", packinfo.ReturnData);
                    }
                    if (_productdesc.length > 0) {
                        renderProductDescUI("/includes/rl-modules/wpt/v1/product-description.html", packinfo.ReturnData);
                        if (getURLParameter("detail")) {
                            setTimeout(function () {
                                $("html, body").animate({
                                    scrollTop: $("._productdesc-area ._productdesc-desc").offset().top + $("._productdesc-area ._productdesc-desc").outerHeight() - $(window).height() * 0.5
                                }, 1000);
                            }, 1000);
                        }
                    }
                } else {
                    var errorMsg = '';
                    switch (response.ReturnCode) {
                        case RLReturnCode.DBError.value:
                            errorMsg = 'DB error.';
                            break;
                        case RLReturnCode.IDNoDataFound.value:
                            errorMsg = 'No data.';
                            break;
                        case RLReturnCode.OperateFail.value:
                            errorMsg = 'Operate fail';
                            break;
                        case RLReturnCode.NotAuth.value:
                            errorMsg = 'Not auth.';
                            break;
                        case RLReturnCode.ParamError.value:
                            errorMsg = 'Param error.';
                            break;
                        default:
                            errorMsg = 'unknow fail.';
                            break;
                    }
                }
            }

            if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object") {
                $.when(_loadScript()).then(function () {
                    renderLayout(data);
                });
            } else {
                var deferred = $.Deferred();
                $.when(_loadScript()).then(function () {
                    var _apiURL = rlServerURL.API + apiUrl.detailInfo + "?RequestUrl=" + window.location.href;
                    var param = {
                        preview: false
                    };
                    urlDomain = rlServerURL.MainWeb;

                    $.ajax({
                        type: "GET",
                        url: _apiURL,
                        contentType: "application/json",
                        dataType: "json",
                        data: param,
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function success(response) {
                            renderLayout(response);
                            deferred.resolve(response);
                        },
                        error: function error(err) {
                            deferred.reject(err);
                        }
                    });
                });
                return deferred.promise();
            }
        };
        //=====product description UI===============
        var renderProductDescUI = function renderProductDescUI(templateUrl, data) {
            function execIconlistSlick() {
                $(".rl-slide-icon").slick({
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    autoplaySpeed: 3000,
                    arrows: true,
                    dots: true,
                    infinite: true,
                    responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }, {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6
                        }
                    }, {
                        breakpoint: 580,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    }]
                });
            }

            $.get(templateUrl, function (response) {
                _productdesc.html(response);
                $("._productdesc-title").html(data.CSItem.Name.toUpperCase());
                data.CSItem.Description = data.CSItem.Description.replace(new RegExp('\r\n', 'g'), '<br>').replace(new RegExp('&lt;', 'g'), '<').replace(new RegExp('&gt;', 'g'), '>');
                $("._productdesc-desc").html(data.CSItem.Description);
                $("._productdesc-iconlist").append(renderIconListUI(data)).promise().done(function () {
                    execIconlistSlick();
                });
                $("._productdesc-artist").append(renderProductDescArtistUI(data));
                $("._productdesc-packinclude-item").append(renderPackIncludeUI(data));
                renderProductDescNoteUI(data);

                $("._productdesc").removeClass("rl-hidden");
                $("._productdesc-area").removeClass("rl-hidden");
                global.rlModule.grid();
                if ($("._productdesc-packinclude-item").html() !== '') {
                    $("._productdesc-packinclude").removeClass("rl-hidden");
                } else {
                    $("._packdetail-grid .rl-flex-space").addClass("rl-hidden");
                }

                $("._rl-toggle-title").css('cursor', 'pointer').on('click', function () {
                    $(this).parent().find("._rl-toggle-item").slideToggle();
                    $(this).toggleClass('open');
                });
            });
        };

        var renderProductDescNoteUI = function renderProductDescNoteUI(data) {
            //hidden condition
            var deferred = $.Deferred();

            if (data.DisplayBaseRequireItem.length > 0 || data.CCDDisplayPack.length > 0 || data.BaseRequirePack.length > 0 || data.DisplayDRMRequiredItem.length > 0) {

                var productDescNoteItem1 = '';
                var productDescNoteItem2 = '';
                var productDescNoteItem3 = '';
                $("._productdesc-note").removeClass("rl-hidden"); //show note

                if (data.DisplayBaseRequireItem.length > 0) {
                    productDescNoteItem1 = productDescNoteItem1 + 'Some items in the pack require base models for them to function properly. If you do not have the following base contents, you may get incorrect results.<br><br>You could purchse these item(s) from the Marketplace:<br><br>';

                    for (var i = 0; i < data.DisplayBaseRequireItem.length; i++) {
                        var displayBaseRequireItem = data.DisplayBaseRequireItem[i];
                        var productDescNoteItem1_p1 = '';
                        var productDescNoteItem1_p2 = '';
                        productDescNoteItem1 = productDescNoteItem1 + '<span>';
                        for (var j = 0; j < displayBaseRequireItem.RequireItems.length; j++) {
                            var requireItems = displayBaseRequireItem.RequireItems[j];
                            var needComma = j + 1 != displayBaseRequireItem.RequireItems.length ? '<span> , </span>' : '';

                            productDescNoteItem1_p1 = productDescNoteItem1_p1 + '<span><a href="' + requireItems.Url + '" class="theme-link2" target="_blank">' + requireItems.Name + '</a>' + needComma + '</span>';
                        }

                        if (displayBaseRequireItem.RequirePacks.length > 0) {
                            productDescNoteItem1_p2 = productDescNoteItem1_p2 + '<span><br> To learn more about these items or to purchase related items for a better deal, please go to:<br>';
                            for (var k = 0; k < displayBaseRequireItem.RequirePacks.length; k++) {
                                var requiredpack = displayBaseRequireItem.RequirePacks[k];
                                var needComma = k + 1 != displayBaseRequireItem.RequirePacks.length ? '<span> , </span>' : '';

                                productDescNoteItem1_p2 = productDescNoteItem1_p2 + '<span><a href="' + requiredpack.Url + '" class="theme-link2" target="_blank">' + requiredpack.Name + '</a>' + needComma + '</span>';
                            }
                            productDescNoteItem1_p2 = productDescNoteItem1_p2 + '</span><br><br>';
                        }

                        productDescNoteItem1 = productDescNoteItem1 + productDescNoteItem1_p1 + productDescNoteItem1_p2 + '</span>';
                    }
                    //productDescNoteItem1 = productDescNoteItem1 + '<br/><br/>';
                    $("._productdesc-notetext-1").html(productDescNoteItem1);
                }
                if (data.BaseRequirePack.length > 0) {
                    productDescNoteItem2 = productDescNoteItem2 + 'Some items in this pack require base models that can only find in content packs to function correctly. If you do not have the following base contents you may get incorrect results.<br /><br />The require models can be found in the following pack(s):<br />';
                    var productDescNoteItem2_p1 = '';
                    for (var i = 0; i < data.BaseRequirePack.length; i++) {
                        var baseRequirePack = data.BaseRequirePack[i];
                        var needComma = i + 1 != data.BaseRequirePack.length ? '<span> , </span>' : '';

                        productDescNoteItem2_p1 = productDescNoteItem2_p1 + '<span><a href="' + baseRequirePack.Url + '" class="theme-link2" target="_blank">' + baseRequirePack.Name + '</a>' + needComma + '</span>';
                    }
                    productDescNoteItem2 = productDescNoteItem2 + productDescNoteItem2_p1;
                    $("._productdesc-notetext-2").html(productDescNoteItem2);
                }
                if (data.CCDDisplayPack.length > 0 || data.DisplayDRMRequiredItem.length > 0) {
                    productDescNoteItem3 = productDescNoteItem3 + 'This is a derivative content from the following base content. Please make sure you have the base content for this content to function as a full version. A derivative content can not be uploaded for sale unless it is modified from a base content. ';

                    var productDescNoteItem3_p1 = '';
                    var productDescNoteItem3_p2 = '';
                    if (data.CCDDisplayPack.length > 0) {
                        for (var i = 0; i < data.CCDDisplayPack.length; i++) {
                            var ccdDisplayPack = data.CCDDisplayPack[i];
                            var needComma = i + 1 != data.CCDDisplayPack.length ? '<span> , </span>' : '';

                            productDescNoteItem3_p1 = productDescNoteItem3_p1 + '<span><a href="' + ccdDisplayPack.Url + '" class="theme-link2" target="_blank">' + ccdDisplayPack.Name + '</a>' + needComma + '</span>';
                        }
                    }

                    if (data.DisplayDRMRequiredItem.length > 0) {
                        for (var i = 0; i < data.DisplayDRMRequiredItem.length; i++) {
                            var displayDRMRequiredItem = data.DisplayDRMRequiredItem[i];
                            var needComma = i + 1 != data.DisplayDRMRequiredItem.length ? '<span> , </span>' : '';

                            productDescNoteItem3_p2 = productDescNoteItem3_p2 + '<span><a href="' + displayDRMRequiredItem.Url + '" class="theme-link2" target="_blank">' + displayDRMRequiredItem.Name + '</a>' + needComma + '</span>';
                        }
                    }

                    productDescNoteItem3 = productDescNoteItem3 + productDescNoteItem3_p1 + productDescNoteItem3_p2;
                    $("._productdesc-notetext-3").html(productDescNoteItem3);
                }

                //productDescNoteUI = productDescNoteItem1 + productDescNoteItem2 + productDescNoteItem3;
                //_productdesc-notetext-1
                deferred.resolve();
            }

            return deferred.promise();
        };

        var renderPackIncludeUI = function renderPackIncludeUI(data) {
            var packIncludeUI = '';

            for (var i = 0; i < data.IncludePack.length; i++) {
                packIncludeUI += "\n                  <li class=\"rl-fontweight-regular rl-lineheight-12\" style=\"color: #767676; font-size:18px\">\n                    " + data.IncludePack[i].Quantifier + " (" + data.IncludePack[i].Qty + ") \n                    " + (data.IncludePack[i].Description.length == 0 ? '' : "<br><span style=\"font-size: 12px; color: #b1b1b1\">" + data.IncludePack[i].Description + "</span>") + "\n                  </li>";
            }

            return packIncludeUI;
        };

        var renderProductDescArtistUI = function renderProductDescArtistUI(data) {
            var productDescArtistUI = '';
            if (data.CSItem.FDAuthor != null && data.CSItem.FDAuthor.length > 0) {
                productDescArtistUI = '<a href="' + urlDomain + websiteName + 'FeaturedDeveloper/profile/#!/' + encodeURIComponent(data.CSItem.FDAuthor) + '" class="theme-link2 rl-text-h2 rl-fontweight-lighter" target="_self">' + data.CSItem.Author + '</a>';
            } else {
                productDescArtistUI = '<a href="' + urlDomain + websiteName + 'index.html?author=' + encodeURIComponent(data.CSItem.Author) + '&CategoryID=' + data.CSItem.CategoryID + '" class="theme-link2 rl-text-h2 rl-fontweight-lighter" target="_self">' + data.CSItem.Author + '</a>';
            }

            return productDescArtistUI;
        };

        var renderIconListUI = function renderIconListUI(pageInfoData) {
            var processIconlist = function processIconlist() {
                var processedIconList = [];

                if (pageInfoData.PageType != pageType.ct) {
                    var tempIconList = pageInfoData.IconList;

                    var pushIconListItem = function pushIconListItem(tempIconList, name, imgName, pathName) {
                        tempIconList.push({
                            Name: name,
                            IconImage: pageInfoData.IconPath + imgName,
                            IconImageLink: pathName,
                            Type: iconListTypeEnum.SPEC
                        });
                    };

                    if (pageInfoData.PageType == pageType.aud) {
                        pushIconListItem(tempIconList, "Audio", "icon_audio.gif", "content/spec/?p=ic#IC-Audio");
                    } else {
                        if (pageInfoData.PageType != pageType.cta) {
                            switch (pageInfoData.PolySize) {
                                case modelPolygonSizeEnum.LOW:
                                    pushIconListItem(tempIconList, "Model Polygon Size - Low", "IC-Pro-Low.svg", "content/spec/?p=ic#IC-Pro-Low");
                                    break;
                                case modelPolygonSizeEnum.MID:
                                    pushIconListItem(tempIconList, "Model Polygon Size - Mid", "IC-Pro-Mid.svg", "content/spec/?p=ic#IC-Pro-Mid");
                                    break;
                                case modelPolygonSizeEnum.HIGH:
                                    pushIconListItem(tempIconList, "Model Polygon Size - High", "IC-Pro-Hi.svg", "content/spec/?p=ic#IC-Pro-Hi");
                                    break;
                            }

                            switch (pageInfoData.Resolution) {
                                case textureResolutionEnum.LOW:
                                    pushIconListItem(tempIconList, "Texture Resolution - Low", "IC-Res-Low.svg", "content/spec/?p=ic#IC-Res-Low");
                                    break;
                                case textureResolutionEnum.MID:
                                    pushIconListItem(tempIconList, "Texture Resolution - Mid", "IC-Res-Mid.svg", "content/spec/?p=ic#IC-Res-Mid");
                                    break;
                                case textureResolutionEnum.HIGH:
                                    pushIconListItem(tempIconList, "Texture Resolution - High", "IC-Res-Hi.svg", "content/spec/?p=ic#IC-Res-Hi");
                                    break;
                            }
                        }
                    }

                    var nonExportableNote = tempIconList.some(function (icon) {
                        return icon.Type === iconListTypeEnum.SPEC && icon.IconImage !== null && icon.Name === 'IC-Non-Exportable';
                    }) ? "\n                            <p class=\"rl-fontweight-regular rl-lineheight-15 rl-row-top-calc-10\" style=\"font-size: 12px; color: #b1b1b1;\">\n                                *Please note that this content includes non exportable content which can only be used within Reallusion applications. See \n                                <a href=\"/content/spec/default.html#IC-Non-Exportable\" class=\"theme-link2\" style=\"font-size: inherit;\" target=\"_blank\">Content Specifications</a>.\n                            </p>\n                        " : '';

                    processedIconList = [{
                        title: "Content spec：",
                        icons: tempIconList.filter(function (icon) {
                            return icon.Type === iconListTypeEnum.SPEC && icon.IconImage !== null;
                        }),
                        note: nonExportableNote
                    }, {
                        title: "Attribute：",
                        icons: tempIconList.filter(function (icon) {
                            return icon.Type === iconListTypeEnum.ATTRIBUTE && icon.IconImage !== null;
                        })
                    }];
                } else {
                    processedIconList = [];
                }

                return processedIconList;
            };

            var iconListUI = processIconlist(pageInfoData).reduce(function (result, iconlist, index) {
                if (iconlist.icons.length > 0) {
                    result += "\n                        " + (result != '' && index % 2 === 1 ? '<div class="rl-line-iconlist-wrapper"><div class="rl-line-iconlist"></div></div>' : '') + "\n                        <div class=\"icon-list grid-item\"> \n                            <div class=\"rl-fontweight-regular rl-lineheight-12 rl-row-bottom-20 product-desc-title\">" + iconlist.title + "</div>\n                                <div class=\"rl-slide-icon\">\n                                    " + iconlist.icons.map(function (iconItem) {
                        return "\n                                        <a href=\"" + (rlServerURL.MainWeb + (iconItem.IconImageLink || 'content/spec/')) + "\" title=\"" + iconItem.Name + "\" target=\"_blank\">\n                                            <img src=\"" + (rlServerURL.MainWeb + iconItem.IconImage) + "\" alt=\"" + iconItem.Name + "\" class=\"img-responsive\">\n                                        </a>\n                                    ";
                    }).join('') + "\n                                </div>\n                            " + (iconlist.note ? iconlist.note : '') + "\n                        </div>\n                    ";
                }

                return result;
            }, '');

            return iconListUI;
        };

        //===== End of product description UI===============

        //=====product price UI===============
        var renderProductPriceUI = function renderProductPriceUI(templateUrl, data) {
            var urlAddFrom = getURLParameter('addfrom');
            var buyLinkAddFrom = '';
            if (urlAddFrom !== null && urlAddFrom !== '') {
                buyLinkAddFrom = '&addfrom=' + urlAddFrom;
            } else if ($(".rl-contentpackprice[data-add-from]").length > 0) {
                buyLinkAddFrom = '&addfrom=' + $(".rl-contentpackprice").data("add-from");
            }
            $.get(templateUrl, function (response) {
                var authorLink;
                var pageType = {
                    "ic": 0,
                    "ct": 1,
                    "aud": 2,
                    "cta": 3,
                    "cc": 4
                };
                if ($("[data-content-pid=" + data.CSItem.ContentID + "] ._productprice").length) {
                    _productprice = $("[data-content-pid=" + data.CSItem.ContentID + "] ._productprice");
                }
                var isHidePackInfo = _productprice.parent().attr("hide-pack-info") === "";
                var isShowKnowMoreButton = _productprice.parent().attr("show-know-more-button") === "";

                _productprice.html(response);
                setWishListIconState(pageInfoData.CSItem.InWishList);
                _productprice.find("#share-url-input").val(window.location.href);
                _productprice.find(".contentpack-packname .value").text(data.CSItem.Name);

                //Binding Author
                if (data.CSItem.FDAuthor != null && data.CSItem.FDAuthor != '') {
                    authorLink = "/contentstore/FeaturedDeveloper/profile/#!/";
                    _productprice.find(".contentpack-author .value a").attr({ title: data.CSItem.FDAuthor, href: authorLink + encodeURIComponent(data.CSItem.FDAuthor) }).text(data.CSItem.Author);
                } else {
                    authorLink = "/contentstore/index.html?Author=";
                    _productprice.find(".contentpack-author .value a").attr({ title: data.CSItem.Author, href: authorLink + encodeURIComponent(data.CSItem.Author) + '&CategoryID=' + data.CSItem.CategoryID }).text(data.CSItem.Author);
                }

                //Breadcrumb
                var result = [];
                var node = data.LocationBar.SubItem;
                while (node) {
                    result.push({ Name: node.Name, Url: node.Url });
                    node = node.SubItem;
                }

                if (result.at(-1).Name.trim() === result.at(-2).Name.trim()) {
                    result.pop();
                }

                var $breadcrumbContainer = _productprice.find('.contentpack-breadcrumb .value');
                $breadcrumbContainer.empty();

                var breadcrumbHtml = result.map(function (_ref) {
                    var Name = _ref.Name,
                        Url = _ref.Url;

                    if (Url) {
                        return "<a class=\"breadcrumb-link\" href=\"" + Url + "\" target=\"_self\" title=\"" + Name + "\">" + Name + "</a>";
                    } else {
                        return "<span class=\"breadcrumb-text\">" + Name + "</span>";
                    }
                }).join("<span class=\"breadcrumb-pattern\">\xA0>\xA0</span>");

                $breadcrumbContainer.append(breadcrumbHtml);

                //Binding Required Info
                var $requiredInfo = _productprice.find(".contentpack-profile");
                var $divideline = _productprice.find(".mobile-col-one .theme-divideline");
                if (textInfo.requiredVersionText) {
                    $requiredInfo.show();
                    $divideline.show();
                    _productprice.find(".contentpack-profile-required").text(textInfo.requiredVersionText);
                } else {
                    $requiredInfo.hide();
                    $divideline.hide();
                }
                //View pack items link
                if (_productdesc.length > 0 && data.IncludePack.length > 0) {
                    _productprice.find(".contentpack-view-pack-items").removeClass("rl-hidden");
                    _productprice.find(".contentpack-view-pack-items").on('click', function () {
                        setTimeout(function () {
                            $("html, body").animate({
                                scrollTop: $("._productdesc-packinclude").offset().top + $("._productdesc-packinclude").outerHeight() - 0.5 * $(window).height()
                            }, 500);
                        }, 10);
                    });
                }

                if (isHidePackInfo) {
                    _productprice.find(".contentpack-item-container .contentpack-profile").hide();
                    _productprice.find(".contentpack-line").hide();
                }

                //Binding Price Area
                function setAddToCartButton($el, data, addFrom) {
                    var link = "" + data.CSItem.Buylink + addFrom;

                    if (data.DisplayBaseRequireItem.length > 0 || data.CCDDisplayPack.length > 0 || data.BaseRequirePack.length > 0 || data.DisplayDRMRequiredItem.length > 0) {
                        $el.parent("a").off('click.addToCart');
                        $el.parent("a").on('click.addToCart', function (event) {
                            event.preventDefault();
                            magnificDialog('Base Content Required for Full Functionality! To avoid having watermark, you need to purchase base content on product page.', '', [{ text: 'OK', returnCode: 'ok' }]).then(function (returnCode) {
                                location.href = link;
                            });
                        });
                    }

                    $el.parent("a").attr("href", link);
                }

                function setPriceArea(data) {
                    var displayPrice = data.CSItem.Price;
                    var displayListPrice = data.CSItem.ListPrice;

                    if (displayPrice != null) {
                        _productprice.find(".contentpack-price .price").text(padDecimal(displayPrice));

                        if (displayListPrice != displayPrice) {
                            var percent = Math.round((displayListPrice - displayPrice) / displayListPrice * 100);
                            _productprice.find(".contentpack-price .percent-off").text(percent + "% OFF");
                            _productprice.find(".contentpack-price .list-price").text(padDecimal(displayListPrice));
                            _productprice.find(".contentpack-price .discount-info").show();
                        } else {
                            _productprice.find(".contentpack-price .discount-info").hide();
                        }

                        if (data.CSItem.VisibilityId == null || data.CSItem.VisibilityId == 0) {
                            setAddToCartButton(_productprice.find(".contentpack-price .btn-buy"), data, buyLinkAddFrom);
                            _productprice.find(".contentpack-price .btn-buy").show();
                        } else {
                            _productprice.find(".contentpack-price .btn-buy").hide();
                        }
                    }
                }

                setPriceArea(data);

                if (data.CSItem.DisplayMessageType !== displayMessageTypeForDiscontinuedContentEnum.SHOW_DEFAULT_MESSAGE) {
                    _productprice.find(".contentpack-price").show();
                }

                if (data.CSItem.Price != null && data.CSItem.Price == 0 && data.PageType == pageType.ic) {
                    _productprice.find(".contentpack-note").show();
                }

                if (data.CSItem.DisplayMessageType === displayMessageTypeForDiscontinuedContentEnum.SHOW_DEFAULT_MESSAGE) {
                    _productprice.find(".promotion-container .promotion-title-wrapper").text("Sorry. The link you followed is no longer available. Go back to Content Store to check further the latest products.");
                    _productprice.find(".promotion-container .promotion-endDate-wrapper").hide();
                    fitText("._productprice .promotion-container .promotion-title-wrapper", 2);

                    //show previous purchased button
                    _productprice.find(".previous-purchased-container").removeClass("rl-hidden");
                    _productprice.find(".previous-purchased-container a").click(function (e) {
                        e.preventDefault();
                        if (_productdesc) {
                            $("html, body").animate({
                                scrollTop: _productdesc.offset().top
                            }, 1000);
                        }
                    });
                } else if (data.CSItem.DisplayMessageType !== displayMessageTypeForDiscontinuedContentEnum.HIDDEN) {
                    //Binding Promotion Info
                    if (data.CSItem.PromotionName) {
                        if (data.CSItem.PromotionURL) {
                            _productprice.find(".promotion-container").attr({ "href": data.CSItem.PromotionURL, "target": "_blank" });
                        }
                        _productprice.find(".promotion-container .promotion-title-wrapper").html(data.CSItem.PromotionName);
                    }
                    if (data.CSItem.PromotionEndDate) {
                        var date = new Date(data.CSItem.PromotionEndDate);
                        var promotionEndDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
                        fitText("._productprice .promotion-container .promotion-title-wrapper", 2);
                        _productprice.find(".promotion-container .promotion-endDate-wrapper").find(".date").text(promotionEndDate + " ( UTC )");
                    } else {
                        _productprice.find(".promotion-container .promotion-endDate-wrapper").hide();
                    }
                    if (!data.CSItem.PromotionName && !data.CSItem.PromotionEndDate) {
                        _productprice.find(".promotion-container").hide();
                    }
                } else {
                    _productprice.find(".promotion-container").hide();
                }

                //Binding Know More Link
                if (data.CSItem.ProductLink != "" && isShowKnowMoreButton) {
                    _productprice.find(".know-more-container a").attr("href", data.CSItem.ProductLink);
                } else {
                    _productprice.find(".know-more-container").hide();
                }

                global.rlModule.grid();

                setTimeout(function () {
                    scalePriceContainerByWindowResize();
                    shiftPriceAreaWhenScroll();
                }, 0);
                $(window).on("resize", function () {
                    scalePriceContainerByWindowResize();
                });
            });
        };

        //=====End of product price UI===============
        var scalePriceContainerByWindowResize = function scalePriceContainerByWindowResize() {
            var maxWidth = $('.rl-contentpackprice').width();
            var windowSize = window.innerWidth;
            var ratio = maxWidth * 1920 / windowSize;
            var scale = maxWidth / ratio;

            if (windowSize <= 767) {
                $('.rl-contentpackprice').css({
                    '-webkit-transform': '',
                    '-ms-transform': '',
                    'transform': '',
                    '-webkit-transform-origin': '',
                    '-ms-transform-origin': '',
                    'transform-origin': ''
                });
            } else {
                scale = Math.min(1.0, scale);
                scale = Math.max(0.5, scale);
                $('.rl-contentpackprice').css({
                    '-webkit-transform': 'scale(' + scale + ')',
                    '-ms-transform': 'scale(' + scale + ')',
                    'transform': 'scale(' + scale + ')',
                    '-webkit-transform-origin': 'top',
                    '-ms-transform-origin': 'top',
                    'transform-origin': 'top'
                });
            }
        };

        var padDecimal = function padDecimal(number) {
            number = '' + number;
            var decimalNumber = number.split(".");
            if (decimalNumber.length == 2) {
                return decimalNumber[0] + "." + padRight(decimalNumber[1], 2);
            }
            return decimalNumber[0] + "." + padRight('', 2);
        };

        var padRight = function padRight(str, len) {
            str = '' + str;
            if (str.length >= len) {
                return str;
            } else {
                return padRight(str + "0", len);
            }
        };

        var _loadScript = function _loadScript() {
            var deferred = $.Deferred();
            var _scriptServerUrl = (location.protocol + "//" + location.hostname).toLowerCase().replace(/(^http.*:\/\/(.+\-)*)(.*?\.).*/, "$1www.reallusion.com/");

            $.getScript(_scriptServerUrl + _rlServerConfigPath).then(function () {
                var _loadQueue = _requiredFilePaths.map(function (path) {
                    return $.getScript(rlServerURL.MainWeb + path);
                });

                _loadQueue.push($.Deferred(function (defer) {
                    $(defer.resolve);
                }));

                $.when.apply(null, _loadQueue).done(function () {
                    deferred.resolve();
                }).fail(function () {
                    deferred.reject('load required js fail.');
                });
            }).fail(function () {
                deferred.reject('load rlServer config fail.');
            });

            return deferred.promise();
        };

        var fitText = function fitText(elementSelector) {
            var lineClamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            var targets = $(elementSelector);
            var timer;
            var originCss = {};
            var updateTextFontSize = function updateTextFontSize(target) {
                var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
                var lastScrollHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

                target.css({
                    "display": "-webkit-box",
                    "-webkit-box-orient": "vertical",
                    "-webkit-line-clamp": String(lineClamp),
                    "overflow": "hidden",
                    "font-size": fontSize + "px"
                });
                var offsetHeight = target[0].offsetHeight;
                var scrollHeight = target[0].scrollHeight;
                var titleLineHeight = parseInt(target.css("line-height"));
                if (scrollHeight - offsetHeight >= titleLineHeight && scrollHeight != lastScrollHeight) {
                    updateTextFontSize(target, fontSize - 1, scrollHeight);
                } else if (scrollHeight == lastScrollHeight) {
                    target.css(originCss);
                }
            };

            if (targets.length > 0) {
                targets.each(function () {
                    if ($(this).text() != "" && $(this).css("display") != "none") {
                        originCss.display = $(this).css("display");
                        originCss.overflow = $(this).css("overflow");
                        var initialFontSize = parseInt($(this).css("font-size"));
                        updateTextFontSize($(this), initialFontSize);
                        var vm = this;
                        $(global).resize(function () {
                            clearTimeout(timer);
                            timer = setTimeout(function () {
                                updateTextFontSize($(vm), initialFontSize);
                            }, 100);
                        });
                    }
                });
            }
        };

        _module.copyShareLink = function () {
            var textToCopy = document.querySelector('#share-url-input').value;
            navigator.clipboard.writeText(textToCopy);
        };

        _module.closeSharePanel = function () {
            $.magnificPopup.close();
        };

        function magnificDialog(message, title, buttons) {
            return new Promise(function (resolve, reject) {
                $.magnificPopup.open({
                    items: {
                        src: "\n                            <div class=\"magnific-dialog\">\n                                <div class=\"title\">" + title + "</div>\n                                <div class=\"content\">" + message + "</div>\n                                <div class=\"btns\"></div>\n                            </div>\n                        ",
                        type: 'inline'
                    },
                    closeOnBgClick: false,
                    callbacks: {
                        open: function open() {
                            var _this = this;

                            buttons.map(function (button, index) {
                                var btn = $("<button class=\"" + (index == 0 ? 'primary' : '') + "\">" + button.text + "</button>");
                                btn.click(function () {
                                    $.magnificPopup.proto.close.call(this);
                                    resolve(button.returnCode);
                                });
                                $(_this.content).find('.btns').append(btn);
                            });

                            $(this.content).find('.mfp-close').click(function () {
                                resolve('close');
                            });
                        }
                    }
                });
            });
        };

        _module.getRequiredVersionAndBuyButtonText = function (packData) {
            var extraInfo = {};

            function requiredVersion(packData) {
                var csRequiredVersions = packData.RequiredVersions;
                var hasCsRequiredVersions = csRequiredVersions && csRequiredVersions.length > 0;
                var requireVersionList = [];

                var getCategoryName = function getCategoryName(category) {
                    var categoryName = void 0;
                    switch (category) {
                        case "ic":
                        case "iclone":
                            categoryName = "iC";
                            break;
                        case "cta":
                        case "cartoon animator":
                            categoryName = "CTA";
                            break;
                        case "cc":
                        case "character creator":
                            categoryName = "CC";
                            break;
                        case "ct":
                        case "crazytalk":
                            categoryName = "CT";
                            break;
                        case "media":
                            categoryName = "Popvideo";
                            break;
                        case "wc":
                            categoryName = "WidgetCast";
                            break;
                        case "crossap":
                            categoryName = "Cross Product";
                            break;
                    }

                    return categoryName;
                };

                var versionFormat = function versionFormat(version) {
                    return 'v' + (version / 100).toFixed(2);
                };

                var getVersion = function getVersion(versionInfo) {
                    var BeginVersion = versionInfo.BeginVersion,
                        EndVersion = versionInfo.EndVersion,
                        PluginVersion = versionInfo.PluginVersion;

                    var version = '';
                    if (PluginVersion) {
                        version = PluginVersion.map(function (versionNumber) {
                            return versionFormat(versionNumber);
                        }).join(', ');
                    } else if (BeginVersion && EndVersion) {
                        version = versionFormat(versionInfo.BeginVersion) + ' to < ' + versionFormat(versionInfo.EndVersion);
                    } else if (BeginVersion) {
                        version = versionFormat(versionInfo.BeginVersion) + ' or above';
                    } else if (EndVersion) {
                        version = 'below ' + versionFormat(versionInfo.EndVersion);
                    }
                    return version;
                };

                if (packData.MKPInfo) {
                    var mkpRequiredVersions = packData.MKPInfo.RequireOneOfProduct;
                    var hasmkpRequiredVersions = mkpRequiredVersions && mkpRequiredVersions.length != 0;

                    if (hasmkpRequiredVersions && (!hasCsRequiredVersions || mkpRequiredVersions.length >= csRequiredVersions.length)) {
                        requireVersionList = mkpRequiredVersions.reduce(function (result, item) {
                            var productCategory = getCategoryName(item.CategoryID) + ' ';

                            if (productCategory) {
                                result.push(productCategory + getVersion(item));
                            }

                            return result;
                        }, []);
                    }
                }

                if (requireVersionList.length === 0 && hasCsRequiredVersions) {
                    requireVersionList = csRequiredVersions.reduce(function (result, requiredVersion) {
                        var productType = getCategoryName(requiredVersion.CategoryName.toLowerCase());

                        if (productType) {
                            result.push(productType + ' ' + requiredVersion.VersionName + (requiredVersion.VersionOnly ? " only" : " or above") + (requiredVersion.Description.length > 0 ? " (" + requiredVersion.Description + ")" : ''));
                        }

                        return result;
                    }, []);
                }

                return requireVersionList.length > 0 ? requireVersionList.join("; ") + '.' : '';
            }

            if (packData) {
                extraInfo = {
                    requiredVersionText: requiredVersion(packData),
                    buyIcontentButtonText: 'Add to Cart',
                    buyExportButtonText: 'Add to Cart'
                };
            }

            return extraInfo;
        };

        _module.shareLink = function (type) {
            var _url = window.location.href;
            switch (type) {
                case "fb":
                    window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(_url));
                    break;
                case "twitter":
                    window.open("https://twitter.com/share?url=" + encodeURIComponent(_url) + "&text=" + pageInfoData.CSItem.Name + " in Content Store");
                    break;
            }
        };

        return _module;
    }();
})(window);
var app = angular.module('wpt', ["TopNav"]);
app.config(['$locationProvider', '$httpProvider', function ($locationProvider, $httpProvider) {
    $locationProvider.html5Mode({ enabled: true, requireBase: false });
}]);
app.provider("AsyncJSLoadProvider", function () {
    var _RequiredJSPaths = ['/includes/script/modules/rlServerConfig.js', '/includes/script/modules/RLGlobal_Variable.js'];
    var _scriptServerUrl = location.origin.toLowerCase().replace(/(^http.*:\/\/(.+\-)*)(.*?\.).*/, "$1www.reallusion.com") + '/';

    var _loadQueue = _RequiredJSPaths.map(function (path) {
        return $.getScript(_scriptServerUrl + path);
    });

    this.$get = function ($q) {
        var deferred = $q.defer();
        var self = this;
        return {
            getScript: function getScript() {
                $.when.apply(null, _loadQueue).then(function () {
                    deferred.resolve();
                });
                return deferred.promise;
            }
        };
    };
});
app.controller('wptCtrl', ['$scope', '$location', '$rootScope', '$timeout', 'AsyncJSLoadProvider', '$http', '$q', '$window', '$sce', function ($scope, $location, $rootScope, $timeout, AsyncJSLoadProvider, $http, $q, $window, $sce) {
    AsyncJSLoadProvider.getScript().then(function () {
        $scope.urlDomain = rlServerURL.MainWeb;
        $scope.apiDomain = rlServerURL.API;
        $scope.storeApiDomain = rlServerURL.Store;
        $scope.imgDomain = $scope.urlDomain;
        $scope.websiteName = "contentstore/";
        $scope.ReturnCode = {
            None: 0,
            DBError: 1,
            OperateSuccess: 2,
            OperateFail: 3,
            ParamError: 4,
            IDNoDataFound: 5,
            Expire: 6,
            NotAuth: 7,
            Repeat: 8,
            ParseError: 9,
            IOError: 10,
            Unhandled: 11
        };

        $scope.apiUrl = {
            PageView: "ContentData/v1/Pack/PageView",
            RecommendedCotent: "ContentData/v2/Pack/BuyAlsoList?RequestUrl=" + window.location.href,
            RecentlyView: "ContentData/v2/User/RecentlyView?RequestUrl=" + window.location.href,
            AddToCart: "cart.aspx"
        };

        $scope.httpType = {
            "POST": "post",
            "GET": "get"
        };

        $scope.recentlyViewData = {};
        $scope.recommandedContentData = {};

        $rootScope.Math = window.Math;

        //Add To Cart status
        var msgStatus = {
            "default": "",
            "success": "Added to Cart",
            "fail": "Please try again later."
        };
        $scope.msg = msgStatus.default;

        //functions
        var parseAndDecodeResult = function parseAndDecodeResult(value) {
            var decompressData = JSON.parse(LZString.decompressFromUTF16(value));
            return decompressData;
        };

        var httpFunction = function httpFunction(method, url, data, header, withCredentials) {
            var deferred = $q.defer();
            $http({
                method: method,
                url: url,
                data: data == null || data == '' ? '' : data,
                headers: header == null || header == '' ? {} : header,
                withCredentials: withCredentials == null || withCredentials == '' ? false : true
            }).then(function successCallback(response) {
                deferred.resolve(response);
            }, function errorCallback(response) {
                deferred.reject();
            });
            return deferred.promise;
        };

        //page view: record visit record
        var recordPageView = function recordPageView() {
            httpFunction($scope.httpType.POST, $scope.apiDomain + $scope.apiUrl.PageView, { RequestUrl: window.location.href }, { 'Content-Type': 'application/json; charset=utf-8' }, true).then(function (response) {}, function (response) {
                console.log("ajax fail");
            });
        };

        //Recently View
        var recordRecentlyView = function recordRecentlyView() {
            httpFunction($scope.httpType.POST, $scope.apiDomain + $scope.apiUrl.RecentlyView, '', { 'Content-Type': 'application/json; charset=utf-8' }, true).then(function (response) {}, function (response) {
                console.log("ajax fail");
            });
        };

        var gtmImpression = function gtmImpression(data, list) {
            var Products = new Array();
            $.each(data, function (i, v) {
                Products.push({
                    "id": v.ContentID,
                    "name": v.Name,
                    "list": list,
                    "brand": $.trim(v.Author.toLowerCase()),
                    "category": v.CategoryName.replace("/", "_") + "/" + v.SubCategoryName.replace("/", "_") + "/" + v.Type.replace("/", "_"),
                    "variant": "",
                    "position": i + 1,
                    "price": ""
                });
            });

            dataLayer.push({
                'ecommerce': { 'impressions': undefined, 'detail': undefined },
                'eventLabel': undefined,
                'click': undefined
            });

            dataLayer.push({
                'event': 'ECEvent',
                'eventCategory': 'Ecommerce',
                'eventAction': 'product list',
                'ecommerce': {
                    'impressions': Products
                }
            });
        };

        var getRecentlyView = function getRecentlyView() {
            httpFunction($scope.httpType.GET, $scope.apiDomain + $scope.apiUrl.RecentlyView, '', { 'Content-Type': 'application/json; charset=utf-8', 'Compress-Output': 'true' }, true).then(function (response) {
                if (response != null && $scope.ReturnCode.OperateSuccess === response.data.ReturnCode) {
                    $scope.recentlyViewData = parseAndDecodeResult(response.data.ReturnData);
                    gtmImpression($scope.recentlyViewData, "content page recentview");
                    $timeout(function () {
                        $("#_loading-recently").fadeOut();
                    }, 1000);
                    recordRecentlyView();
                } else {
                    $("#_loading-recently").fadeOut();
                    console.log("get data fail");
                }
            }, function (response) {
                $("#_loading-recently").fadeOut();
                console.log("ajax fail");
            });
        };

        //Recommanded Content
        var getRecommandedContent = function getRecommandedContent() {
            httpFunction($scope.httpType.GET, $scope.apiDomain + $scope.apiUrl.RecommendedCotent, '', { 'Content-Type': 'application/json; charset=utf-8', 'Compress-Output': 'true' }, true).then(function (response) {
                if (response != null && $scope.ReturnCode.OperateSuccess === response.data.ReturnCode) {
                    $scope.recommandedContentData = parseAndDecodeResult(response.data.ReturnData);
                    gtmImpression($scope.recommandedContentData, "content page cross-sell");
                    $timeout(function () {
                        $("#_loading-recommanded").fadeOut();
                    }, 1000);
                } else {
                    $("#_loading-recently").fadeOut();
                    console.log("get data fail");
                }
            }, function (response) {
                $("#_loading-recently").fadeOut();
                console.log("ajax fail");
            });
        };

        $scope.showTooltip = function (target, message) {
            var tooltip = document.createElement('div');
            tooltip.className = 'tooltip';

            var arrow = document.createElement('div');
            arrow.className = 'tooltip-arrow';
            tooltip.appendChild(arrow);

            var messageElement = document.createElement('div');
            messageElement.className = 'tooltip-message';
            messageElement.innerText = message;
            tooltip.appendChild(messageElement);

            document.body.appendChild(tooltip);

            function removeTooltipPosClasses(element) {
                element.className = element.className.replace(/\btooltip-pos-\S+/g, '').trim();
            }

            function positionTooltip() {
                removeTooltipPosClasses(arrow);

                var targetRect = target.getBoundingClientRect();
                var tooltipRect = tooltip.getBoundingClientRect();
                var screenPadding = 10;
                var viewportWidth = document.documentElement.clientWidth;
                var viewportHeight = document.documentElement.clientHeight;

                var position = {
                    top: 0,
                    left: 0,
                    arrowLeft: ''
                };

                // Check available space
                var spaceBelow = viewportHeight - targetRect.bottom - screenPadding;
                var spaceAbove = targetRect.top - screenPadding;
                var spaceLeft = targetRect.left - screenPadding;
                var spaceRight = viewportWidth - targetRect.right - screenPadding;

                // tooltip position
                if (spaceBelow >= tooltipRect.height) {
                    position.top = targetRect.bottom + window.scrollY + screenPadding;
                    position.left = targetRect.left + window.scrollX + targetRect.width / 2 - tooltipRect.width / 2;
                    arrow.classList.add('tooltip-pos-bottom');
                } else if (spaceAbove >= tooltipRect.height) {
                    position.top = targetRect.top + window.scrollY - tooltipRect.height - screenPadding;
                    position.left = targetRect.left + window.scrollX + targetRect.width / 2 - tooltipRect.width / 2;
                    arrow.classList.add('tooltip-pos-top');
                } else if (spaceLeft >= tooltipRect.width) {
                    position.top = targetRect.top + window.scrollY + targetRect.height / 2 - tooltipRect.height / 2;
                    position.left = targetRect.left + window.scrollX - tooltipRect.width - screenPadding;
                    arrow.classList.add('tooltip-pos-left');
                } else if (spaceRight >= tooltipRect.width) {
                    position.top = targetRect.top + window.scrollY + targetRect.height / 2 - tooltipRect.height / 2;
                    position.left = targetRect.right + window.scrollX + screenPadding;
                    arrow.classList.add('tooltip-pos-right');
                }

                // Adjust Tooltip Horizontal Position
                if (['tooltip-pos-bottom', 'tooltip-pos-top'].includes(arrow.className.split(' ')[1])) {
                    if (position.left + tooltipRect.width > viewportWidth - screenPadding) {
                        position.left = viewportWidth - tooltipRect.width - screenPadding;
                        position.arrowLeft = targetRect.left - position.left + targetRect.width / 2;
                    }
                }

                // set tooltip and arrow position
                if (position.top !== undefined) tooltip.style.top = position.top + "px";
                if (position.left !== undefined) tooltip.style.left = position.left + "px";
                if (position.arrowLeft) arrow.style.left = position.arrowLeft + "px";
            }

            positionTooltip();
            tooltip.style.visibility = 'visible';
            tooltip.style.opacity = '1';

            setTimeout(function () {
                tooltip.style.opacity = '0';
                setTimeout(function () {
                    document.body.removeChild(tooltip);
                }, 300);
            }, 1200);
        };

        $scope.addToCart = function ($event, _licenseType, buylink, csbuylink) {
            var obj = $event.currentTarget;
            //API Param
            var url = buylink || csbuylink;
            url = url.replace(/http:\/\//g, 'https://');

            if (url) {
                httpFunction($scope.httpType.GET, url, '', { "accept": 'application/json' }, true).then(function (response) {
                    if (response.data != null && $scope.ReturnCode.OperateSuccess === response.data.status) {
                        $scope.showTooltip(obj, msgStatus.success);
                        if (response.data.data.TotalQty > 99) {
                            $("#cartNum").addClass('count-cart');
                            $("#cartNum").text("99");
                        } else if (response.data.data.TotalQty == 0) {
                            $("#cartNum").text("");
                        } else {
                            $("#cartNum").addClass('count-cart');
                            $("#cartNum").text(response.data.data.TotalQty);
                        }
                    } else {
                        $scope.showTooltip(obj, msgStatus.fail);
                        console.log("get data fail");
                    }
                }, function (response) {
                    $scope.showTooltip(obj, msgStatus.fail);
                    console.log("ajax fail");
                });
            }
        };

        // initGA();
        recordPageView();
        getRecentlyView();
        getRecommandedContent();
    });
}]).directive('contentItem', ['$rootScope', function ($rootScope) {
    return {
        restrict: 'E',
        templateUrl: '/contentstore/include/template/contentItem-tpl.html',
        scope: {
            gaSource: '@',
            pageDataItem: '=pageData',
            contentIndex: '=contentIndex',
            pageType: '=pageType',
            imgDomain: '=imgDomain',
            websiteName: '=websiteName',
            ccdCtrlFn: '&callbackFn'
        },
        link: function link($scope, element, attrs) {
            $scope.icon_cart = '/includes/images/icon_all.svg#add_to_cart';

            $scope.isCartHover = function (_type, isHoverAction) {
                $scope.icon_cart = '/includes/images/icon_all.svg?' + parseInt(new Date().getTime() / (1000 * 60 * 60)) + (isHoverAction ? '#add_to_cart_hover' : '#add_to_cart');
            };

            $scope.addToCart = function ($event) {
                var contentBuylink = $scope.pageDataItem.BuyLink;

                if ($scope.pageDataItem.AddFromID || $scope.pageDataItem.AddFromID === 0) {
                    var url = new URL(contentBuylink);
                    var params = new URLSearchParams(new URL(url).search);

                    params.set('addfrom', $scope.pageDataItem.AddFromID);

                    contentBuylink = url.origin + url.pathname + '?' + params.toString();
                }

                $scope.ccdCtrlFn({
                    contentEvent: $event,
                    contentlicenseType: undefined,
                    contentBuylink: contentBuylink,
                    contentCSBuylink: $scope.pageDataItem.CSBuyLink
                });
            };

            //GA Tracking                
            $scope.GATrackingForProductClick = function () {
                dataLayer.push({
                    'event': 'ECEvent',
                    'eventCategory': 'Ecommerce',
                    'eventAction': 'product click',
                    'eventLabel': undefined,
                    'ecommerce': {
                        'impressions': undefined,
                        'detail': undefined,
                        'click': {
                            'actionField': { 'list': $scope.gaSource },
                            'products': [{
                                'id': $scope.pageDataItem.ContentID,
                                'name': $scope.pageDataItem.Name,
                                'brand': $.trim($scope.pageDataItem.Author.toLowerCase()),
                                'category': $scope.pageDataItem.CategoryName.replace("/", "_") + "/" + $scope.pageDataItem.SubCategoryName.replace("/", "_") + "/" + $scope.pageDataItem.Type.replace("/", "_"),
                                'variant': 'standard',
                                'price': $scope.pageDataItem.Price,
                                'qty': 1,
                                'coupon': '',
                                'position': $scope.contentIndex
                            }]
                        }
                    }
                });
            };

            $scope.GATrackingForAuthorClick = function () {
                dataLayer.push({
                    'eventCategory': 'content-store-index',
                    'eventAction': 'author',
                    'eventLabel': $scope.pageDataItem.Author,
                    'event': 'GAEvent'
                });
            };

            $scope.encodeURIComponent = function (string) {
                return encodeURIComponent(string);
            };
        }
    };
}]).directive('slickWpt', function ($timeout) {
    return function (scope, el, attrs) {
        $timeout(function () {
            el.slick({
                arrows: true,
                infinite: false,
                autoplay: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                dots: true,
                responsive: [{
                    breakpoint: 1140,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 870,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        }, 1200);
    };
});

document.addEventListener('DOMContentLoaded', function () {
    var style = document.createElement('style');
    style.innerHTML = "\n            .tooltip {\n                position: absolute;\n                background-color: #ffa105;\n                color: #fff;\n                padding: 7px 10px;\n                visibility: hidden;\n                opacity: 0;\n                transition: opacity 0.3s;\n                white-space: nowrap;\n                z-index: 1000;\n                font-size: calc(0.125vw + 13.6px);\n                margin-left: 2px;\n                text-align: center;\n                font-family: roboto;\n                border: none;\n                min-width: 120px;\n            }\n            .tooltip-arrow {\n                position: absolute;\n                width: 0;\n                height: 0;\n                border-width: 5px;\n                border-style: solid;\n            }\n            .tooltip-arrow.tooltip-pos-bottom {\n                border-color: transparent transparent #ffa105 transparent;\n                top: -10px;\n                left: 50%;\n                transform: translateX(-50%);\n            }\n            .tooltip-arrow.tooltip-pos-top {\n                border-color: #ffa105 transparent transparent transparent;\n                bottom: -10px;\n                left: 50%;\n                transform: translateX(-50%);\n            }\n            .tooltip-arrow.tooltip-pos-left {\n                border-color: transparent transparent transparent #ffa105;\n                top: 50%;\n                right: -10px;\n                transform: translateY(-50%);\n            }\n            .tooltip-arrow.tooltip-pos-right {\n                border-color: transparent #ffa105 transparent transparent;\n                top: 50%;\n                left: -10px;\n                transform: translateY(-50%);\n            }\n        ";
    document.head.appendChild(style);
});
(function (global) {
    if (global.rlModule.rlVideoShow) {
        console.log('rlVideoShow is defined!');
        return;
    }

    global.rlModule.rlVideoShow = function () {
        var _module = {};
        var _videodata = {};
        var _videoshowarea = {};

        var _videoPreviewData = {};
        var mp4Data = [];
        var _selectedIndex = -1;

        var imgpath = '';
        var mp4path = '';
        var numberOfRightCol = 6;

        $(function () {
            _videodata = $(".mp4-module");
            _videoshowarea = $(".rl-videoshow");
            imgpath = _videodata.data("imagepath");
            mp4path = _videodata.data("mp4path");
            numberOfRightCol = _videodata.data("number-of-right-cols");
            if (_videodata.length > 0 && _videoshowarea.length > 0) {
                _module.renderUI();
            }
        });

        _module.renderUI = function () {
            _videoPreviewData = $("PreviewData").find("VideoInfo");

            $.when(appendData(_videoPreviewData)).then(function () {
                $("._thumbnail").click(function () {
                    if (_selectedIndex !== -1) {
                        var _lastSelectedObj = $("#mp4-container").find('._thumbnail').eq(_selectedIndex);
                        $(_lastSelectedObj).children('img').attr('src', getImagePath($(_videoPreviewData[_selectedIndex]).find("Name").text(), false));
                    }
                    _selectedIndex = $(this).data("index");

                    $("#mp4video").addClass("loading");
                    var _mp4 = $(_videoPreviewData[_selectedIndex]);
                    $("#mp4name").html(_mp4.find("Name").text());
                    $("#mp4desc").html(_mp4.find("Desc").text());
                    $("#mp4video").attr("src", mp4path + _mp4.find("Name").text() + ".mp4");
                    $(this).children('img').attr('src', getImagePath($(_videoPreviewData[_selectedIndex]).find("Name").text(), true));
                });

                $("._thumbnail").eq(0).trigger('click');

                $("#mp4video").bind('loadeddata', function (e) {
                    $(this).removeClass("loading");
                });

                var $slick_slider = $('#mp4-container');
                var settings = {
                    infinite: false,
                    dots: true,
                    slidesToShow: 5,
                    slidesToScroll: 5
                };
                if (window.innerWidth < 767) {
                    $slick_slider.slick(settings);
                }

                $(window).on('resize', function () {
                    if (window.innerWidth > 767) {
                        if ($slick_slider.hasClass('slick-initialized')) {
                            $slick_slider.slick('unslick');
                        }
                        return;
                    }
                    if (!$slick_slider.hasClass('slick-initialized')) {
                        return $slick_slider.slick(settings);
                    }
                });
            });
        };

        function appendData(_arrayData) {
            var deferred = $.Deferred();
            for (var index = 0; index < _arrayData.length; index++) {
                var videoPreviewData = _arrayData[index];
                $("#mp4-container").append("<div class='_thumbnail' data-index=" + index + " style='width: calc( 100% / " + numberOfRightCol + ");'><img src='" + getImagePath($(videoPreviewData).find("Name").text(), false) + "'></div>");
            }

            deferred.resolve();
            return deferred.promise();
        }

        function getImagePath(name, selected) {
            if (selected) {
                return imgpath + name + "-1.jpg";
            } else {
                return imgpath + name + ".jpg";
            }
        }

        return _module;
    }();
})(window);